var Io = Object.defineProperty;
var Fo = (e, t, r) => t in e ? Io(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var we = (e, t, r) => Fo(e, typeof t != "symbol" ? t + "" : t, r);
import { getCurrentLocale as Lo, isValidLocale as No } from "@fond-of/locale";
function jn(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Do } = Object.prototype, { getPrototypeOf: lr } = Object, et = /* @__PURE__ */ ((e) => (t) => {
  const r = Do.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), le = (e) => (e = e.toLowerCase(), (t) => et(t) === e), tt = (e) => (t) => typeof t === e, { isArray: xe } = Array, De = tt("undefined");
function jo(e) {
  return e !== null && !De(e) && e.constructor !== null && !De(e.constructor) && ie(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Bn = le("ArrayBuffer");
function Bo(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Bn(e.buffer), t;
}
const ko = tt("string"), ie = tt("function"), kn = tt("number"), rt = (e) => e !== null && typeof e == "object", Uo = (e) => e === !0 || e === !1, Je = (e) => {
  if (et(e) !== "object")
    return !1;
  const t = lr(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, $o = le("Date"), Mo = le("File"), qo = le("Blob"), Ho = le("FileList"), Wo = (e) => rt(e) && ie(e.pipe), zo = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ie(e.append) && ((t = et(e)) === "formdata" || // detect form-data instance
  t === "object" && ie(e.toString) && e.toString() === "[object FormData]"));
}, Ko = le("URLSearchParams"), [Go, Vo, Jo, Qo] = ["ReadableStream", "Request", "Response", "Headers"].map(le), Xo = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Be(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), xe(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const a = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = a.length;
    let s;
    for (n = 0; n < i; n++)
      s = a[n], t.call(null, e[s], s, e);
  }
}
function Un(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const $n = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Mn = (e) => !De(e) && e !== $n;
function Zt() {
  const { caseless: e } = Mn(this) && this || {}, t = {}, r = (n, o) => {
    const a = e && Un(t, o) || o;
    Je(t[a]) && Je(n) ? t[a] = Zt(t[a], n) : Je(n) ? t[a] = Zt({}, n) : xe(n) ? t[a] = n.slice() : t[a] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && Be(arguments[n], r);
  return t;
}
const Yo = (e, t, r, { allOwnKeys: n } = {}) => (Be(t, (o, a) => {
  r && ie(o) ? e[a] = jn(o, r) : e[a] = o;
}, { allOwnKeys: n }), e), Zo = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), ei = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, ti = (e, t, r, n) => {
  let o, a, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), a = o.length; a-- > 0; )
      i = o[a], (!n || n(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = r !== !1 && lr(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, ri = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, ni = (e) => {
  if (!e) return null;
  if (xe(e)) return e;
  let t = e.length;
  if (!kn(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, oi = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && lr(Uint8Array)), ii = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, ai = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, si = le("HTMLFormElement"), ui = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), _r = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), ci = le("RegExp"), qn = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Be(r, (o, a) => {
    let i;
    (i = t(o, a, e)) !== !1 && (n[a] = i || o);
  }), Object.defineProperties(e, n);
}, li = (e) => {
  qn(e, (t, r) => {
    if (ie(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (ie(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, fi = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((a) => {
      r[a] = !0;
    });
  };
  return xe(e) ? n(e) : n(String(e).split(t)), r;
}, pi = () => {
}, yi = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, ht = "abcdefghijklmnopqrstuvwxyz", Cr = "0123456789", Hn = {
  DIGIT: Cr,
  ALPHA: ht,
  ALPHA_DIGIT: ht + ht.toUpperCase() + Cr
}, di = (e = 16, t = Hn.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function hi(e) {
  return !!(e && ie(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const mi = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (rt(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const a = xe(n) ? [] : {};
        return Be(n, (i, s) => {
          const l = r(i, o + 1);
          !De(l) && (a[s] = l);
        }), t[o] = void 0, a;
      }
    }
    return n;
  };
  return r(e, 0);
}, gi = le("AsyncFunction"), vi = (e) => e && (rt(e) || ie(e)) && ie(e.then) && ie(e.catch), g = {
  isArray: xe,
  isArrayBuffer: Bn,
  isBuffer: jo,
  isFormData: zo,
  isArrayBufferView: Bo,
  isString: ko,
  isNumber: kn,
  isBoolean: Uo,
  isObject: rt,
  isPlainObject: Je,
  isReadableStream: Go,
  isRequest: Vo,
  isResponse: Jo,
  isHeaders: Qo,
  isUndefined: De,
  isDate: $o,
  isFile: Mo,
  isBlob: qo,
  isRegExp: ci,
  isFunction: ie,
  isStream: Wo,
  isURLSearchParams: Ko,
  isTypedArray: oi,
  isFileList: Ho,
  forEach: Be,
  merge: Zt,
  extend: Yo,
  trim: Xo,
  stripBOM: Zo,
  inherits: ei,
  toFlatObject: ti,
  kindOf: et,
  kindOfTest: le,
  endsWith: ri,
  toArray: ni,
  forEachEntry: ii,
  matchAll: ai,
  isHTMLForm: si,
  hasOwnProperty: _r,
  hasOwnProp: _r,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: qn,
  freezeMethods: li,
  toObjectSet: fi,
  toCamelCase: ui,
  noop: pi,
  toFiniteNumber: yi,
  findKey: Un,
  global: $n,
  isContextDefined: Mn,
  ALPHABET: Hn,
  generateString: di,
  isSpecCompliantForm: hi,
  toJSONObject: mi,
  isAsyncFn: gi,
  isThenable: vi
};
function I(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
g.inherits(I, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: g.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Wn = I.prototype, zn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  zn[e] = { value: e };
});
Object.defineProperties(I, zn);
Object.defineProperty(Wn, "isAxiosError", { value: !0 });
I.from = (e, t, r, n, o, a) => {
  const i = Object.create(Wn);
  return g.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), I.call(i, e.message, t, r, n, o), i.cause = e, i.name = e.name, a && Object.assign(i, a), i;
};
const bi = null;
function er(e) {
  return g.isPlainObject(e) || g.isArray(e);
}
function Kn(e) {
  return g.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ir(e, t, r) {
  return e ? e.concat(t).map(function(o, a) {
    return o = Kn(o), !r && a ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function wi(e) {
  return g.isArray(e) && !e.some(er);
}
const Si = g.toFlatObject(g, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function nt(e, t, r) {
  if (!g.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = g.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, f) {
    return !g.isUndefined(f[w]);
  });
  const n = r.metaTokens, o = r.visitor || u, a = r.dots, i = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && g.isSpecCompliantForm(t);
  if (!g.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(v) {
    if (v === null) return "";
    if (g.isDate(v))
      return v.toISOString();
    if (!l && g.isBlob(v))
      throw new I("Blob is not supported. Use a Buffer instead.");
    return g.isArrayBuffer(v) || g.isTypedArray(v) ? l && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function u(v, w, f) {
    let y = v;
    if (v && !f && typeof v == "object") {
      if (g.endsWith(w, "{}"))
        w = n ? w : w.slice(0, -2), v = JSON.stringify(v);
      else if (g.isArray(v) && wi(v) || (g.isFileList(v) || g.endsWith(w, "[]")) && (y = g.toArray(v)))
        return w = Kn(w), y.forEach(function(O, P) {
          !(g.isUndefined(O) || O === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Ir([w], P, a) : i === null ? w : w + "[]",
            c(O)
          );
        }), !1;
    }
    return er(v) ? !0 : (t.append(Ir(f, w, a), c(v)), !1);
  }
  const S = [], b = Object.assign(Si, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: er
  });
  function d(v, w) {
    if (!g.isUndefined(v)) {
      if (S.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      S.push(v), g.forEach(v, function(y, h) {
        (!(g.isUndefined(y) || y === null) && o.call(
          t,
          y,
          g.isString(h) ? h.trim() : h,
          w,
          b
        )) === !0 && d(y, w ? w.concat(h) : [h]);
      }), S.pop();
    }
  }
  if (!g.isObject(e))
    throw new TypeError("data must be an object");
  return d(e), t;
}
function Fr(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function fr(e, t) {
  this._pairs = [], e && nt(e, this, t);
}
const Gn = fr.prototype;
Gn.append = function(t, r) {
  this._pairs.push([t, r]);
};
Gn.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Fr);
  } : Fr;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function Oi(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Vn(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Oi, o = r && r.serialize;
  let a;
  if (o ? a = o(t, r) : a = g.isURLSearchParams(t) ? t.toString() : new fr(t, r).toString(n), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Lr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    g.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Jn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ei = typeof URLSearchParams < "u" ? URLSearchParams : fr, Pi = typeof FormData < "u" ? FormData : null, Ai = typeof Blob < "u" ? Blob : null, Ti = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ei,
    FormData: Pi,
    Blob: Ai
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, pr = typeof window < "u" && typeof document < "u", Ri = ((e) => pr && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), xi = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", _i = pr && window.location.href || "http://localhost", Ci = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: pr,
  hasStandardBrowserEnv: Ri,
  hasStandardBrowserWebWorkerEnv: xi,
  origin: _i
}, Symbol.toStringTag, { value: "Module" })), ce = {
  ...Ci,
  ...Ti
};
function Ii(e, t) {
  return nt(e, new ce.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, a) {
      return ce.isNode && g.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Fi(e) {
  return g.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Li(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let a;
  for (n = 0; n < o; n++)
    a = r[n], t[a] = e[a];
  return t;
}
function Qn(e) {
  function t(r, n, o, a) {
    let i = r[a++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = a >= r.length;
    return i = !i && g.isArray(o) ? o.length : i, l ? (g.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !s) : ((!o[i] || !g.isObject(o[i])) && (o[i] = []), t(r, n, o[i], a) && g.isArray(o[i]) && (o[i] = Li(o[i])), !s);
  }
  if (g.isFormData(e) && g.isFunction(e.entries)) {
    const r = {};
    return g.forEachEntry(e, (n, o) => {
      t(Fi(n), o, r, 0);
    }), r;
  }
  return null;
}
function Ni(e, t, r) {
  if (g.isString(e))
    try {
      return (t || JSON.parse)(e), g.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const ke = {
  transitional: Jn,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, a = g.isObject(t);
    if (a && g.isHTMLForm(t) && (t = new FormData(t)), g.isFormData(t))
      return o ? JSON.stringify(Qn(t)) : t;
    if (g.isArrayBuffer(t) || g.isBuffer(t) || g.isStream(t) || g.isFile(t) || g.isBlob(t) || g.isReadableStream(t))
      return t;
    if (g.isArrayBufferView(t))
      return t.buffer;
    if (g.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Ii(t, this.formSerializer).toString();
      if ((s = g.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return nt(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return a || o ? (r.setContentType("application/json", !1), Ni(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || ke.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (g.isResponse(t) || g.isReadableStream(t))
      return t;
    if (t && g.isString(t) && (n && !this.responseType || o)) {
      const i = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? I.from(s, I.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ce.classes.FormData,
    Blob: ce.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
g.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ke.headers[e] = {};
});
const Di = g.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ji = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && Di[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Nr = Symbol("internals");
function Le(e) {
  return e && String(e).trim().toLowerCase();
}
function Qe(e) {
  return e === !1 || e == null ? e : g.isArray(e) ? e.map(Qe) : String(e);
}
function Bi(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const ki = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function mt(e, t, r, n, o) {
  if (g.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!g.isString(t)) {
    if (g.isString(n))
      return t.indexOf(n) !== -1;
    if (g.isRegExp(n))
      return n.test(t);
  }
}
function Ui(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function $i(e, t) {
  const r = g.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, a, i) {
        return this[n].call(this, t, o, a, i);
      },
      configurable: !0
    });
  });
}
let X = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function a(s, l, c) {
      const u = Le(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const S = g.findKey(o, u);
      (!S || o[S] === void 0 || c === !0 || c === void 0 && o[S] !== !1) && (o[S || l] = Qe(s));
    }
    const i = (s, l) => g.forEach(s, (c, u) => a(c, u, l));
    if (g.isPlainObject(t) || t instanceof this.constructor)
      i(t, r);
    else if (g.isString(t) && (t = t.trim()) && !ki(t))
      i(ji(t), r);
    else if (g.isHeaders(t))
      for (const [s, l] of t.entries())
        a(l, s, n);
    else
      t != null && a(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Le(t), t) {
      const n = g.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return Bi(o);
        if (g.isFunction(r))
          return r.call(this, o, n);
        if (g.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Le(t), t) {
      const n = g.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || mt(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function a(i) {
      if (i = Le(i), i) {
        const s = g.findKey(n, i);
        s && (!r || mt(n, n[s], s, r)) && (delete n[s], o = !0);
      }
    }
    return g.isArray(t) ? t.forEach(a) : a(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const a = r[n];
      (!t || mt(this, this[a], a, t, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return g.forEach(this, (o, a) => {
      const i = g.findKey(n, a);
      if (i) {
        r[i] = Qe(o), delete r[a];
        return;
      }
      const s = t ? Ui(a) : String(a).trim();
      s !== a && delete r[a], r[s] = Qe(o), n[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return g.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && g.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[Nr] = this[Nr] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(i) {
      const s = Le(i);
      n[s] || ($i(o, i), n[s] = !0);
    }
    return g.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
X.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
g.reduceDescriptors(X.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
g.freezeMethods(X);
function gt(e, t) {
  const r = this || ke, n = t || r, o = X.from(n.headers);
  let a = n.data;
  return g.forEach(e, function(s) {
    a = s.call(r, a, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), a;
}
function Xn(e) {
  return !!(e && e.__CANCEL__);
}
function _e(e, t, r) {
  I.call(this, e ?? "canceled", I.ERR_CANCELED, t, r), this.name = "CanceledError";
}
g.inherits(_e, I, {
  __CANCEL__: !0
});
function Yn(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new I(
    "Request failed with status code " + r.status,
    [I.ERR_BAD_REQUEST, I.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Mi(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function qi(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, a = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = n[a];
    i || (i = c), r[o] = l, n[o] = c;
    let S = a, b = 0;
    for (; S !== o; )
      b += r[S++], S = S % e;
    if (o = (o + 1) % e, o === a && (a = (a + 1) % e), c - i < t)
      return;
    const d = u && c - u;
    return d ? Math.round(b * 1e3 / d) : void 0;
  };
}
function Hi(e, t) {
  let r = 0;
  const n = 1e3 / t;
  let o = null;
  return function() {
    const i = this === !0, s = Date.now();
    if (i || s - r > n)
      return o && (clearTimeout(o), o = null), r = s, e.apply(null, arguments);
    o || (o = setTimeout(() => (o = null, r = Date.now(), e.apply(null, arguments)), n - (s - r)));
  };
}
const Xe = (e, t, r = 3) => {
  let n = 0;
  const o = qi(50, 250);
  return Hi((a) => {
    const i = a.loaded, s = a.lengthComputable ? a.total : void 0, l = i - n, c = o(l), u = i <= s;
    n = i;
    const S = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: a,
      lengthComputable: s != null
    };
    S[t ? "download" : "upload"] = !0, e(S);
  }, r);
}, Wi = ce.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function o(a) {
      let i = a;
      return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = o(window.location.href), function(i) {
      const s = g.isString(i) ? o(i) : i;
      return s.protocol === n.protocol && s.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), zi = ce.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, a) {
      const i = [e + "=" + encodeURIComponent(t)];
      g.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), g.isString(n) && i.push("path=" + n), g.isString(o) && i.push("domain=" + o), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ki(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Gi(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Zn(e, t) {
  return e && !Ki(t) ? Gi(e, t) : t;
}
const Dr = (e) => e instanceof X ? { ...e } : e;
function Pe(e, t) {
  t = t || {};
  const r = {};
  function n(c, u, S) {
    return g.isPlainObject(c) && g.isPlainObject(u) ? g.merge.call({ caseless: S }, c, u) : g.isPlainObject(u) ? g.merge({}, u) : g.isArray(u) ? u.slice() : u;
  }
  function o(c, u, S) {
    if (g.isUndefined(u)) {
      if (!g.isUndefined(c))
        return n(void 0, c, S);
    } else return n(c, u, S);
  }
  function a(c, u) {
    if (!g.isUndefined(u))
      return n(void 0, u);
  }
  function i(c, u) {
    if (g.isUndefined(u)) {
      if (!g.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, u);
  }
  function s(c, u, S) {
    if (S in t)
      return n(c, u);
    if (S in e)
      return n(void 0, c);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u) => o(Dr(c), Dr(u), !0)
  };
  return g.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const S = l[u] || o, b = S(e[u], t[u], u);
    g.isUndefined(b) && S !== s || (r[u] = b);
  }), r;
}
const eo = (e) => {
  const t = Pe({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: a, headers: i, auth: s } = t;
  t.headers = i = X.from(i), t.url = Vn(Zn(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (g.isFormData(r)) {
    if (ce.hasStandardBrowserEnv || ce.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((S) => S.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (ce.hasStandardBrowserEnv && (n && g.isFunction(n) && (n = n(t)), n || n !== !1 && Wi(t.url))) {
    const c = o && a && zi.read(a);
    c && i.set(o, c);
  }
  return t;
}, Vi = typeof XMLHttpRequest < "u", Ji = Vi && function(e) {
  return new Promise(function(r, n) {
    const o = eo(e);
    let a = o.data;
    const i = X.from(o.headers).normalize();
    let { responseType: s } = o, l;
    function c() {
      o.cancelToken && o.cancelToken.unsubscribe(l), o.signal && o.signal.removeEventListener("abort", l);
    }
    let u = new XMLHttpRequest();
    u.open(o.method.toUpperCase(), o.url, !0), u.timeout = o.timeout;
    function S() {
      if (!u)
        return;
      const d = X.from(
        "getAllResponseHeaders" in u && u.getAllResponseHeaders()
      ), w = {
        data: !s || s === "text" || s === "json" ? u.responseText : u.response,
        status: u.status,
        statusText: u.statusText,
        headers: d,
        config: e,
        request: u
      };
      Yn(function(y) {
        r(y), c();
      }, function(y) {
        n(y), c();
      }, w), u = null;
    }
    "onloadend" in u ? u.onloadend = S : u.onreadystatechange = function() {
      !u || u.readyState !== 4 || u.status === 0 && !(u.responseURL && u.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, u.onabort = function() {
      u && (n(new I("Request aborted", I.ECONNABORTED, o, u)), u = null);
    }, u.onerror = function() {
      n(new I("Network Error", I.ERR_NETWORK, o, u)), u = null;
    }, u.ontimeout = function() {
      let v = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const w = o.transitional || Jn;
      o.timeoutErrorMessage && (v = o.timeoutErrorMessage), n(new I(
        v,
        w.clarifyTimeoutError ? I.ETIMEDOUT : I.ECONNABORTED,
        o,
        u
      )), u = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in u && g.forEach(i.toJSON(), function(v, w) {
      u.setRequestHeader(w, v);
    }), g.isUndefined(o.withCredentials) || (u.withCredentials = !!o.withCredentials), s && s !== "json" && (u.responseType = o.responseType), typeof o.onDownloadProgress == "function" && u.addEventListener("progress", Xe(o.onDownloadProgress, !0)), typeof o.onUploadProgress == "function" && u.upload && u.upload.addEventListener("progress", Xe(o.onUploadProgress)), (o.cancelToken || o.signal) && (l = (d) => {
      u && (n(!d || d.type ? new _e(null, e, u) : d), u.abort(), u = null);
    }, o.cancelToken && o.cancelToken.subscribe(l), o.signal && (o.signal.aborted ? l() : o.signal.addEventListener("abort", l)));
    const b = Mi(o.url);
    if (b && ce.protocols.indexOf(b) === -1) {
      n(new I("Unsupported protocol " + b + ":", I.ERR_BAD_REQUEST, e));
      return;
    }
    u.send(a || null);
  });
}, Qi = (e, t) => {
  let r = new AbortController(), n;
  const o = function(l) {
    if (!n) {
      n = !0, i();
      const c = l instanceof Error ? l : this.reason;
      r.abort(c instanceof I ? c : new _e(c instanceof Error ? c.message : c));
    }
  };
  let a = t && setTimeout(() => {
    o(new I(`timeout ${t} of ms exceeded`, I.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (a && clearTimeout(a), a = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", o) : l.unsubscribe(o));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", o));
  const { signal: s } = r;
  return s.unsubscribe = i, [s, () => {
    a && clearTimeout(a), a = null;
  }];
}, Xi = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, Yi = async function* (e, t, r) {
  for await (const n of e)
    yield* Xi(ArrayBuffer.isView(n) ? n : await r(String(n)), t);
}, jr = (e, t, r, n, o) => {
  const a = Yi(e, t, o);
  let i = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(s) {
      const { done: l, value: c } = await a.next();
      if (l) {
        s.close(), n();
        return;
      }
      let u = c.byteLength;
      r && r(i += u), s.enqueue(new Uint8Array(c));
    },
    cancel(s) {
      return n(s), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Br = (e, t) => {
  const r = e != null;
  return (n) => setTimeout(() => t({
    lengthComputable: r,
    total: e,
    loaded: n
  }));
}, ot = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", to = ot && typeof ReadableStream == "function", tr = ot && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Zi = to && (() => {
  let e = !1;
  const t = new Request(ce.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
})(), kr = 64 * 1024, rr = to && !!(() => {
  try {
    return g.isReadableStream(new Response("").body);
  } catch {
  }
})(), Ye = {
  stream: rr && ((e) => e.body)
};
ot && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Ye[t] && (Ye[t] = g.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new I(`Response type '${t}' is not supported`, I.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const ea = async (e) => {
  if (e == null)
    return 0;
  if (g.isBlob(e))
    return e.size;
  if (g.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (g.isArrayBufferView(e))
    return e.byteLength;
  if (g.isURLSearchParams(e) && (e = e + ""), g.isString(e))
    return (await tr(e)).byteLength;
}, ta = async (e, t) => {
  const r = g.toFiniteNumber(e.getContentLength());
  return r ?? ea(t);
}, ra = ot && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: o,
    cancelToken: a,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: S = "same-origin",
    fetchOptions: b
  } = eo(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [d, v] = o || a || i ? Qi([o, a], i) : [], w, f;
  const y = () => {
    !w && setTimeout(() => {
      d && d.unsubscribe();
    }), w = !0;
  };
  let h;
  try {
    if (l && Zi && r !== "get" && r !== "head" && (h = await ta(u, n)) !== 0) {
      let A = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), F;
      g.isFormData(n) && (F = A.headers.get("content-type")) && u.setContentType(F), A.body && (n = jr(A.body, kr, Br(
        h,
        Xe(l)
      ), null, tr));
    }
    g.isString(S) || (S = S ? "cors" : "omit"), f = new Request(t, {
      ...b,
      signal: d,
      method: r.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      withCredentials: S
    });
    let O = await fetch(f);
    const P = rr && (c === "stream" || c === "response");
    if (rr && (s || P)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((L) => {
        A[L] = O[L];
      });
      const F = g.toFiniteNumber(O.headers.get("content-length"));
      O = new Response(
        jr(O.body, kr, s && Br(
          F,
          Xe(s, !0)
        ), P && y, tr),
        A
      );
    }
    c = c || "text";
    let E = await Ye[g.findKey(Ye, c) || "text"](O, e);
    return !P && y(), v && v(), await new Promise((A, F) => {
      Yn(A, F, {
        data: E,
        headers: X.from(O.headers),
        status: O.status,
        statusText: O.statusText,
        config: e,
        request: f
      });
    });
  } catch (O) {
    throw y(), O && O.name === "TypeError" && /fetch/i.test(O.message) ? Object.assign(
      new I("Network Error", I.ERR_NETWORK, e, f),
      {
        cause: O.cause || O
      }
    ) : I.from(O, O && O.code, e, f);
  }
}), nr = {
  http: bi,
  xhr: Ji,
  fetch: ra
};
g.forEach(nr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ur = (e) => `- ${e}`, na = (e) => g.isFunction(e) || e === null || e === !1, ro = {
  getAdapter: (e) => {
    e = g.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let a = 0; a < t; a++) {
      r = e[a];
      let i;
      if (n = r, !na(r) && (n = nr[(i = String(r)).toLowerCase()], n === void 0))
        throw new I(`Unknown adapter '${i}'`);
      if (n)
        break;
      o[i || "#" + a] = n;
    }
    if (!n) {
      const a = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? a.length > 1 ? `since :
` + a.map(Ur).join(`
`) : " " + Ur(a[0]) : "as no adapter specified";
      throw new I(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: nr
};
function vt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new _e(null, e);
}
function $r(e) {
  return vt(e), e.headers = X.from(e.headers), e.data = gt.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ro.getAdapter(e.adapter || ke.adapter)(e).then(function(n) {
    return vt(e), n.data = gt.call(
      e,
      e.transformResponse,
      n
    ), n.headers = X.from(n.headers), n;
  }, function(n) {
    return Xn(n) || (vt(e), n && n.response && (n.response.data = gt.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = X.from(n.response.headers))), Promise.reject(n);
  });
}
const no = "1.7.2", yr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  yr[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Mr = {};
yr.transitional = function(t, r, n) {
  function o(a, i) {
    return "[Axios v" + no + "] Transitional option '" + a + "'" + i + (n ? ". " + n : "");
  }
  return (a, i, s) => {
    if (t === !1)
      throw new I(
        o(i, " has been removed" + (r ? " in " + r : "")),
        I.ERR_DEPRECATED
      );
    return r && !Mr[i] && (Mr[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, i, s) : !0;
  };
};
function oa(e, t, r) {
  if (typeof e != "object")
    throw new I("options must be an object", I.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const a = n[o], i = t[a];
    if (i) {
      const s = e[a], l = s === void 0 || i(s, a, e);
      if (l !== !0)
        throw new I("option " + a + " must be " + l, I.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new I("Unknown option " + a, I.ERR_BAD_OPTION);
  }
}
const or = {
  assertOptions: oa,
  validators: yr
}, ve = or.validators;
let Ee = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Lr(),
      response: new Lr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Pe(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: a } = r;
    n !== void 0 && or.assertOptions(n, {
      silentJSONParsing: ve.transitional(ve.boolean),
      forcedJSONParsing: ve.transitional(ve.boolean),
      clarifyTimeoutError: ve.transitional(ve.boolean)
    }, !1), o != null && (g.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : or.assertOptions(o, {
      encode: ve.function,
      serialize: ve.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = a && g.merge(
      a.common,
      a[r.method]
    );
    a && g.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete a[v];
      }
    ), r.headers = X.concat(i, a);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(r) === !1 || (l = l && w.synchronous, s.unshift(w.fulfilled, w.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(w) {
      c.push(w.fulfilled, w.rejected);
    });
    let u, S = 0, b;
    if (!l) {
      const v = [$r.bind(this), void 0];
      for (v.unshift.apply(v, s), v.push.apply(v, c), b = v.length, u = Promise.resolve(r); S < b; )
        u = u.then(v[S++], v[S++]);
      return u;
    }
    b = s.length;
    let d = r;
    for (S = 0; S < b; ) {
      const v = s[S++], w = s[S++];
      try {
        d = v(d);
      } catch (f) {
        w.call(this, f);
        break;
      }
    }
    try {
      u = $r.call(this, d);
    } catch (v) {
      return Promise.reject(v);
    }
    for (S = 0, b = c.length; S < b; )
      u = u.then(c[S++], c[S++]);
    return u;
  }
  getUri(t) {
    t = Pe(this.defaults, t);
    const r = Zn(t.baseURL, t.url);
    return Vn(r, t.params, t.paramsSerializer);
  }
};
g.forEach(["delete", "get", "head", "options"], function(t) {
  Ee.prototype[t] = function(r, n) {
    return this.request(Pe(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
g.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(a, i, s) {
      return this.request(Pe(s || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  Ee.prototype[t] = r(), Ee.prototype[t + "Form"] = r(!0);
});
let ia = class oo {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let a = n._listeners.length;
      for (; a-- > 0; )
        n._listeners[a](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const i = new Promise((s) => {
        n.subscribe(s), a = s;
      }).then(o);
      return i.cancel = function() {
        n.unsubscribe(a);
      }, i;
    }, t(function(a, i, s) {
      n.reason || (n.reason = new _e(a, i, s), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new oo(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
};
function aa(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function sa(e) {
  return g.isObject(e) && e.isAxiosError === !0;
}
const ir = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ir).forEach(([e, t]) => {
  ir[t] = e;
});
function io(e) {
  const t = new Ee(e), r = jn(Ee.prototype.request, t);
  return g.extend(r, Ee.prototype, t, { allOwnKeys: !0 }), g.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return io(Pe(e, o));
  }, r;
}
const K = io(ke);
K.Axios = Ee;
K.CanceledError = _e;
K.CancelToken = ia;
K.isCancel = Xn;
K.VERSION = no;
K.toFormData = nt;
K.AxiosError = I;
K.Cancel = K.CanceledError;
K.all = function(t) {
  return Promise.all(t);
};
K.spread = aa;
K.isAxiosError = sa;
K.mergeConfig = Pe;
K.AxiosHeaders = X;
K.formToJSON = (e) => Qn(g.isHTMLForm(e) ? new FormData(e) : e);
K.getAdapter = ro.getAdapter;
K.HttpStatusCode = ir;
K.default = K;
const {
  Axios: Au,
  AxiosError: Tu,
  CanceledError: Ru,
  isCancel: xu,
  CancelToken: _u,
  VERSION: Cu,
  all: Iu,
  Cancel: Fu,
  isAxiosError: Lu,
  spread: Nu,
  toFormData: Du,
  AxiosHeaders: ju,
  HttpStatusCode: Bu,
  formToJSON: ku,
  getAdapter: Uu,
  mergeConfig: $u
} = K;
var ua = Function.prototype.toString, bt = Object.create, ca = Object.defineProperty, la = Object.getOwnPropertyDescriptor, qr = Object.getOwnPropertyNames, dr = Object.getOwnPropertySymbols, fa = Object.getPrototypeOf, ao = Object.prototype, pa = ao.hasOwnProperty, ya = ao.propertyIsEnumerable, so = typeof dr == "function", da = typeof WeakMap == "function", ha = function() {
  if (da)
    return function() {
      return /* @__PURE__ */ new WeakMap();
    };
  var e = (
    /** @class */
    function() {
      function t() {
        this._keys = [], this._values = [];
      }
      return t.prototype.has = function(r) {
        return !!~this._keys.indexOf(r);
      }, t.prototype.get = function(r) {
        return this._values[this._keys.indexOf(r)];
      }, t.prototype.set = function(r, n) {
        this._keys.push(r), this._values.push(n);
      }, t;
    }()
  );
  return function() {
    return new e();
  };
}(), uo = function(e, t) {
  var r = e.__proto__ || fa(e);
  if (!r)
    return bt(null);
  var n = r.constructor;
  if (n === t.Object)
    return r === t.Object.prototype ? {} : bt(r);
  if (~ua.call(n).indexOf("[native code]"))
    try {
      return new n();
    } catch {
    }
  return bt(r);
}, ma = function(e, t, r, n) {
  var o = uo(e, t);
  n.set(e, o);
  for (var a in e)
    pa.call(e, a) && (o[a] = r(e[a], n));
  if (so)
    for (var i = dr(e), s = 0, l = i.length, c = void 0; s < l; ++s)
      c = i[s], ya.call(e, c) && (o[c] = r(e[c], n));
  return o;
}, Hr = function(e, t, r, n) {
  var o = uo(e, t);
  n.set(e, o);
  for (var a = so ? qr(e).concat(dr(e)) : qr(e), i = 0, s = a.length, l = void 0, c = void 0; i < s; ++i)
    if (l = a[i], l !== "callee" && l !== "caller")
      if (c = la(e, l), c) {
        !c.get && !c.set && (c.value = r(e[l], n));
        try {
          ca(o, l, c);
        } catch {
          o[l] = c.value;
        }
      } else
        o[l] = r(e[l], n);
  return o;
}, ga = function(e) {
  var t = "";
  return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
}, va = Array.isArray, ba = Object.getPrototypeOf, wa = function() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : (console && console.error && console.error('Unable to locate global object, returning "this".'), this);
}();
function G(e, t) {
  var r = !!(t && t.isStrict), n = t && t.realm || wa, o = r ? Hr : ma, a = function(i, s) {
    if (!i || typeof i != "object")
      return i;
    if (s.has(i))
      return s.get(i);
    var l = i.__proto__ || ba(i), c = l && l.constructor;
    if (!c || c === n.Object)
      return o(i, n, a, s);
    var u;
    if (va(i)) {
      if (r)
        return Hr(i, n, a, s);
      u = new c(), s.set(i, u);
      for (var S = 0, b = i.length; S < b; ++S)
        u[S] = a(i[S], s);
      return u;
    }
    if (i instanceof n.Date)
      return new c(i.getTime());
    if (i instanceof n.RegExp)
      return u = new c(i.source, i.flags || ga(i)), u.lastIndex = i.lastIndex, u;
    if (n.Map && i instanceof n.Map)
      return u = new c(), s.set(i, u), i.forEach(function(d, v) {
        u.set(v, a(d, s));
      }), u;
    if (n.Set && i instanceof n.Set)
      return u = new c(), s.set(i, u), i.forEach(function(d) {
        u.add(a(d, s));
      }), u;
    if (n.Blob && i instanceof n.Blob)
      return i.slice(0, i.size, i.type);
    if (n.Buffer && n.Buffer.isBuffer(i))
      return u = n.Buffer.allocUnsafe ? n.Buffer.allocUnsafe(i.length) : new c(i.length), s.set(i, u), i.copy(u), u;
    if (n.ArrayBuffer) {
      if (n.ArrayBuffer.isView(i))
        return u = new c(i.buffer.slice(0)), s.set(i, u), u;
      if (i instanceof n.ArrayBuffer)
        return u = i.slice(0), s.set(i, u), u;
    }
    return (
      // promise-like
      typeof i.then == "function" || // errors
      i instanceof Error || // weakmaps
      n.WeakMap && i instanceof n.WeakMap || // weaksets
      n.WeakSet && i instanceof n.WeakSet ? i : o(i, n, a, s)
    );
  };
  return a(e, ha());
}
G.default = G;
G.strict = function(t, r) {
  return G(t, {
    isStrict: !0,
    realm: r ? r.realm : void 0
  });
};
var Sa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ue(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Oa(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var wt, Wr;
function Ea() {
  return Wr || (Wr = 1, wt = Error), wt;
}
var St, zr;
function Pa() {
  return zr || (zr = 1, St = EvalError), St;
}
var Ot, Kr;
function Aa() {
  return Kr || (Kr = 1, Ot = RangeError), Ot;
}
var Et, Gr;
function Ta() {
  return Gr || (Gr = 1, Et = ReferenceError), Et;
}
var Pt, Vr;
function co() {
  return Vr || (Vr = 1, Pt = SyntaxError), Pt;
}
var At, Jr;
function $e() {
  return Jr || (Jr = 1, At = TypeError), At;
}
var Tt, Qr;
function Ra() {
  return Qr || (Qr = 1, Tt = URIError), Tt;
}
var Rt, Xr;
function xa() {
  return Xr || (Xr = 1, Rt = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var o = 42;
    t[r] = o;
    for (r in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(t);
    if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var i = Object.getOwnPropertyDescriptor(t, r);
      if (i.value !== o || i.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Rt;
}
var xt, Yr;
function _a() {
  if (Yr) return xt;
  Yr = 1;
  var e = typeof Symbol < "u" && Symbol, t = xa();
  return xt = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, xt;
}
var _t, Zr;
function Ca() {
  if (Zr) return _t;
  Zr = 1;
  var e = {
    __proto__: null,
    foo: {}
  }, t = Object;
  return _t = function() {
    return { __proto__: e }.foo === e.foo && !(e instanceof t);
  }, _t;
}
var Ct, en;
function Ia() {
  if (en) return Ct;
  en = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", o = function(l, c) {
    for (var u = [], S = 0; S < l.length; S += 1)
      u[S] = l[S];
    for (var b = 0; b < c.length; b += 1)
      u[b + l.length] = c[b];
    return u;
  }, a = function(l, c) {
    for (var u = [], S = c, b = 0; S < l.length; S += 1, b += 1)
      u[b] = l[S];
    return u;
  }, i = function(s, l) {
    for (var c = "", u = 0; u < s.length; u += 1)
      c += s[u], u + 1 < s.length && (c += l);
    return c;
  };
  return Ct = function(l) {
    var c = this;
    if (typeof c != "function" || t.apply(c) !== n)
      throw new TypeError(e + c);
    for (var u = a(arguments, 1), S, b = function() {
      if (this instanceof S) {
        var y = c.apply(
          this,
          o(u, arguments)
        );
        return Object(y) === y ? y : this;
      }
      return c.apply(
        l,
        o(u, arguments)
      );
    }, d = r(0, c.length - u.length), v = [], w = 0; w < d; w++)
      v[w] = "$" + w;
    if (S = Function("binder", "return function (" + i(v, ",") + "){ return binder.apply(this,arguments); }")(b), c.prototype) {
      var f = function() {
      };
      f.prototype = c.prototype, S.prototype = new f(), f.prototype = null;
    }
    return S;
  }, Ct;
}
var It, tn;
function hr() {
  if (tn) return It;
  tn = 1;
  var e = Ia();
  return It = Function.prototype.bind || e, It;
}
var Ft, rn;
function Fa() {
  if (rn) return Ft;
  rn = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = hr();
  return Ft = r.call(e, t), Ft;
}
var Lt, nn;
function Ce() {
  if (nn) return Lt;
  nn = 1;
  var e, t = /* @__PURE__ */ Ea(), r = /* @__PURE__ */ Pa(), n = /* @__PURE__ */ Aa(), o = /* @__PURE__ */ Ta(), a = /* @__PURE__ */ co(), i = /* @__PURE__ */ $e(), s = /* @__PURE__ */ Ra(), l = Function, c = function(B) {
    try {
      return l('"use strict"; return (' + B + ").constructor;")();
    } catch {
    }
  }, u = Object.getOwnPropertyDescriptor;
  if (u)
    try {
      u({}, "");
    } catch {
      u = null;
    }
  var S = function() {
    throw new i();
  }, b = u ? function() {
    try {
      return arguments.callee, S;
    } catch {
      try {
        return u(arguments, "callee").get;
      } catch {
        return S;
      }
    }
  }() : S, d = _a()(), v = /* @__PURE__ */ Ca()(), w = Object.getPrototypeOf || (v ? function(B) {
    return B.__proto__;
  } : null), f = {}, y = typeof Uint8Array > "u" || !w ? e : w(Uint8Array), h = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": d && w ? w([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": f,
    "%AsyncGenerator%": f,
    "%AsyncGeneratorFunction%": f,
    "%AsyncIteratorPrototype%": f,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": l,
    "%GeneratorFunction%": f,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": d && w ? w(w([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !d || !w ? e : w((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": n,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !d || !w ? e : w((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": d && w ? w(""[Symbol.iterator]()) : e,
    "%Symbol%": d ? Symbol : e,
    "%SyntaxError%": a,
    "%ThrowTypeError%": b,
    "%TypedArray%": y,
    "%TypeError%": i,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": s,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  if (w)
    try {
      null.error;
    } catch (B) {
      var O = w(w(B));
      h["%Error.prototype%"] = O;
    }
  var P = function B(x) {
    var q;
    if (x === "%AsyncFunction%")
      q = c("async function () {}");
    else if (x === "%GeneratorFunction%")
      q = c("function* () {}");
    else if (x === "%AsyncGeneratorFunction%")
      q = c("async function* () {}");
    else if (x === "%AsyncGenerator%") {
      var k = B("%AsyncGeneratorFunction%");
      k && (q = k.prototype);
    } else if (x === "%AsyncIteratorPrototype%") {
      var W = B("%AsyncGenerator%");
      W && w && (q = w(W.prototype));
    }
    return h[x] = q, q;
  }, E = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, A = hr(), F = /* @__PURE__ */ Fa(), L = A.call(Function.call, Array.prototype.concat), j = A.call(Function.apply, Array.prototype.splice), C = A.call(Function.call, String.prototype.replace), U = A.call(Function.call, String.prototype.slice), _ = A.call(Function.call, RegExp.prototype.exec), Q = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, R = /\\(\\)?/g, T = function(x) {
    var q = U(x, 0, 1), k = U(x, -1);
    if (q === "%" && k !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (k === "%" && q !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var W = [];
    return C(x, Q, function(V, fe, H, re) {
      W[W.length] = H ? C(re, R, "$1") : fe || V;
    }), W;
  }, M = function(x, q) {
    var k = x, W;
    if (F(E, k) && (W = E[k], k = "%" + W[0] + "%"), F(h, k)) {
      var V = h[k];
      if (V === f && (V = P(k)), typeof V > "u" && !q)
        throw new i("intrinsic " + x + " exists, but is not available. Please file an issue!");
      return {
        alias: W,
        name: k,
        value: V
      };
    }
    throw new a("intrinsic " + x + " does not exist!");
  };
  return Lt = function(x, q) {
    if (typeof x != "string" || x.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof q != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (_(/^%?[^%]*%?$/, x) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var k = T(x), W = k.length > 0 ? k[0] : "", V = M("%" + W + "%", q), fe = V.name, H = V.value, re = !1, de = V.alias;
    de && (W = de[0], j(k, L([0, 1], de)));
    for (var he = 1, ne = !0; he < k.length; he += 1) {
      var J = k[he], Z = U(J, 0, 1), pe = U(J, -1);
      if ((Z === '"' || Z === "'" || Z === "`" || pe === '"' || pe === "'" || pe === "`") && Z !== pe)
        throw new a("property names with quotes must have matching quotes");
      if ((J === "constructor" || !ne) && (re = !0), W += "." + J, fe = "%" + W + "%", F(h, fe))
        H = h[fe];
      else if (H != null) {
        if (!(J in H)) {
          if (!q)
            throw new i("base intrinsic for " + x + " exists, but the property is not available.");
          return;
        }
        if (u && he + 1 >= k.length) {
          var ye = u(H, J);
          ne = !!ye, ne && "get" in ye && !("originalValue" in ye.get) ? H = ye.get : H = H[J];
        } else
          ne = F(H, J), H = H[J];
        ne && !re && (h[fe] = H);
      }
    }
    return H;
  }, Lt;
}
var Nt = { exports: {} }, Dt, on;
function mr() {
  if (on) return Dt;
  on = 1;
  var e = /* @__PURE__ */ Ce(), t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return Dt = t, Dt;
}
var jt, an;
function lo() {
  if (an) return jt;
  an = 1;
  var e = /* @__PURE__ */ Ce(), t = e("%Object.getOwnPropertyDescriptor%", !0);
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return jt = t, jt;
}
var Bt, sn;
function La() {
  if (sn) return Bt;
  sn = 1;
  var e = /* @__PURE__ */ mr(), t = /* @__PURE__ */ co(), r = /* @__PURE__ */ $e(), n = /* @__PURE__ */ lo();
  return Bt = function(a, i, s) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new r("`obj` must be an object or a function`");
    if (typeof i != "string" && typeof i != "symbol")
      throw new r("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new r("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new r("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new r("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new r("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, c = arguments.length > 4 ? arguments[4] : null, u = arguments.length > 5 ? arguments[5] : null, S = arguments.length > 6 ? arguments[6] : !1, b = !!n && n(a, i);
    if (e)
      e(a, i, {
        configurable: u === null && b ? b.configurable : !u,
        enumerable: l === null && b ? b.enumerable : !l,
        value: s,
        writable: c === null && b ? b.writable : !c
      });
    else if (S || !l && !c && !u)
      a[i] = s;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Bt;
}
var kt, un;
function Na() {
  if (un) return kt;
  un = 1;
  var e = /* @__PURE__ */ mr(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, kt = t, kt;
}
var Ut, cn;
function Da() {
  if (cn) return Ut;
  cn = 1;
  var e = /* @__PURE__ */ Ce(), t = /* @__PURE__ */ La(), r = /* @__PURE__ */ Na()(), n = /* @__PURE__ */ lo(), o = /* @__PURE__ */ $e(), a = e("%Math.floor%");
  return Ut = function(s, l) {
    if (typeof s != "function")
      throw new o("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || a(l) !== l)
      throw new o("`length` must be a positive 32-bit integer");
    var c = arguments.length > 2 && !!arguments[2], u = !0, S = !0;
    if ("length" in s && n) {
      var b = n(s, "length");
      b && !b.configurable && (u = !1), b && !b.writable && (S = !1);
    }
    return (u || S || !c) && (r ? t(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      l,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      l
    )), s;
  }, Ut;
}
var ln;
function ja() {
  return ln || (ln = 1, function(e) {
    var t = hr(), r = /* @__PURE__ */ Ce(), n = /* @__PURE__ */ Da(), o = /* @__PURE__ */ $e(), a = r("%Function.prototype.apply%"), i = r("%Function.prototype.call%"), s = r("%Reflect.apply%", !0) || t.call(i, a), l = /* @__PURE__ */ mr(), c = r("%Math.max%");
    e.exports = function(b) {
      if (typeof b != "function")
        throw new o("a function is required");
      var d = s(t, i, arguments);
      return n(
        d,
        1 + c(0, b.length - (arguments.length - 1)),
        !0
      );
    };
    var u = function() {
      return s(t, a, arguments);
    };
    l ? l(e.exports, "apply", { value: u }) : e.exports.apply = u;
  }(Nt)), Nt.exports;
}
var $t, fn;
function Ba() {
  if (fn) return $t;
  fn = 1;
  var e = /* @__PURE__ */ Ce(), t = ja(), r = t(e("String.prototype.indexOf"));
  return $t = function(o, a) {
    var i = e(o, !!a);
    return typeof i == "function" && r(o, ".prototype.") > -1 ? t(i) : i;
  }, $t;
}
const ka = {}, Ua = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ka
}, Symbol.toStringTag, { value: "Module" })), $a = /* @__PURE__ */ Oa(Ua);
var Mt, pn;
function Ma() {
  if (pn) return Mt;
  pn = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, a = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = o && a && typeof a.get == "function" ? a.get : null, s = o && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, c = l ? WeakMap.prototype.has : null, u = typeof WeakSet == "function" && WeakSet.prototype, S = u ? WeakSet.prototype.has : null, b = typeof WeakRef == "function" && WeakRef.prototype, d = b ? WeakRef.prototype.deref : null, v = Boolean.prototype.valueOf, w = Object.prototype.toString, f = Function.prototype.toString, y = String.prototype.match, h = String.prototype.slice, O = String.prototype.replace, P = String.prototype.toUpperCase, E = String.prototype.toLowerCase, A = RegExp.prototype.test, F = Array.prototype.concat, L = Array.prototype.join, j = Array.prototype.slice, C = Math.floor, U = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, _ = Object.getOwnPropertySymbols, Q = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, R = typeof Symbol == "function" && typeof Symbol.iterator == "object", T = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === R || !0) ? Symbol.toStringTag : null, M = Object.prototype.propertyIsEnumerable, B = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(p) {
    return p.__proto__;
  } : null);
  function x(p, m) {
    if (p === 1 / 0 || p === -1 / 0 || p !== p || p && p > -1e3 && p < 1e3 || A.call(/e/, m))
      return m;
    var D = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof p == "number") {
      var $ = p < 0 ? -C(-p) : C(p);
      if ($ !== p) {
        var z = String($), N = h.call(m, z.length + 1);
        return O.call(z, D, "$&_") + "." + O.call(O.call(N, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return O.call(m, D, "$&_");
  }
  var q = $a, k = q.custom, W = pe(k) ? k : null;
  Mt = function p(m, D, $, z) {
    var N = D || {};
    if (ae(N, "quoteStyle") && N.quoteStyle !== "single" && N.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (ae(N, "maxStringLength") && (typeof N.maxStringLength == "number" ? N.maxStringLength < 0 && N.maxStringLength !== 1 / 0 : N.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var me = ae(N, "customInspect") ? N.customInspect : !0;
    if (typeof me != "boolean" && me !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (ae(N, "indent") && N.indent !== null && N.indent !== "	" && !(parseInt(N.indent, 10) === N.indent && N.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (ae(N, "numericSeparator") && typeof N.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var be = N.numericSeparator;
    if (typeof m > "u")
      return "undefined";
    if (m === null)
      return "null";
    if (typeof m == "boolean")
      return m ? "true" : "false";
    if (typeof m == "string")
      return br(m, N);
    if (typeof m == "number") {
      if (m === 0)
        return 1 / 0 / m > 0 ? "0" : "-0";
      var ee = String(m);
      return be ? x(m, ee) : ee;
    }
    if (typeof m == "bigint") {
      var ge = String(m) + "n";
      return be ? x(m, ge) : ge;
    }
    var ut = typeof N.depth > "u" ? 5 : N.depth;
    if (typeof $ > "u" && ($ = 0), $ >= ut && ut > 0 && typeof m == "object")
      return H(m) ? "[Array]" : "[Object]";
    var Ae = xo(N, $);
    if (typeof z > "u")
      z = [];
    else if (vr(z, m) >= 0)
      return "[Circular]";
    function se(Te, He, Co) {
      if (He && (z = j.call(z), z.push(He)), Co) {
        var xr = {
          depth: N.depth
        };
        return ae(N, "quoteStyle") && (xr.quoteStyle = N.quoteStyle), p(Te, xr, $ + 1, z);
      }
      return p(Te, N, $ + 1, z);
    }
    if (typeof m == "function" && !de(m)) {
      var Sr = bo(m), Or = Me(m, se);
      return "[Function" + (Sr ? ": " + Sr : " (anonymous)") + "]" + (Or.length > 0 ? " { " + L.call(Or, ", ") + " }" : "");
    }
    if (pe(m)) {
      var Er = R ? O.call(String(m), /^(Symbol\(.*\))_[^)]*$/, "$1") : Q.call(m);
      return typeof m == "object" && !R ? Ie(Er) : Er;
    }
    if (Ao(m)) {
      for (var Fe = "<" + E.call(String(m.nodeName)), ct = m.attributes || [], qe = 0; qe < ct.length; qe++)
        Fe += " " + ct[qe].name + "=" + V(fe(ct[qe].value), "double", N);
      return Fe += ">", m.childNodes && m.childNodes.length && (Fe += "..."), Fe += "</" + E.call(String(m.nodeName)) + ">", Fe;
    }
    if (H(m)) {
      if (m.length === 0)
        return "[]";
      var lt = Me(m, se);
      return Ae && !Ro(lt) ? "[" + st(lt, Ae) + "]" : "[ " + L.call(lt, ", ") + " ]";
    }
    if (he(m)) {
      var ft = Me(m, se);
      return !("cause" in Error.prototype) && "cause" in m && !M.call(m, "cause") ? "{ [" + String(m) + "] " + L.call(F.call("[cause]: " + se(m.cause), ft), ", ") + " }" : ft.length === 0 ? "[" + String(m) + "]" : "{ [" + String(m) + "] " + L.call(ft, ", ") + " }";
    }
    if (typeof m == "object" && me) {
      if (W && typeof m[W] == "function" && q)
        return q(m, { depth: ut - $ });
      if (me !== "symbol" && typeof m.inspect == "function")
        return m.inspect();
    }
    if (wo(m)) {
      var Pr = [];
      return n && n.call(m, function(Te, He) {
        Pr.push(se(He, m, !0) + " => " + se(Te, m));
      }), wr("Map", r.call(m), Pr, Ae);
    }
    if (Eo(m)) {
      var Ar = [];
      return s && s.call(m, function(Te) {
        Ar.push(se(Te, m));
      }), wr("Set", i.call(m), Ar, Ae);
    }
    if (So(m))
      return at("WeakMap");
    if (Po(m))
      return at("WeakSet");
    if (Oo(m))
      return at("WeakRef");
    if (J(m))
      return Ie(se(Number(m)));
    if (ye(m))
      return Ie(se(U.call(m)));
    if (Z(m))
      return Ie(v.call(m));
    if (ne(m))
      return Ie(se(String(m)));
    if (typeof window < "u" && m === window)
      return "{ [object Window] }";
    if (m === Sa)
      return "{ [object globalThis] }";
    if (!re(m) && !de(m)) {
      var pt = Me(m, se), Tr = B ? B(m) === Object.prototype : m instanceof Object || m.constructor === Object, yt = m instanceof Object ? "" : "null prototype", Rr = !Tr && T && Object(m) === m && T in m ? h.call(oe(m), 8, -1) : yt ? "Object" : "", _o = Tr || typeof m.constructor != "function" ? "" : m.constructor.name ? m.constructor.name + " " : "", dt = _o + (Rr || yt ? "[" + L.call(F.call([], Rr || [], yt || []), ": ") + "] " : "");
      return pt.length === 0 ? dt + "{}" : Ae ? dt + "{" + st(pt, Ae) + "}" : dt + "{ " + L.call(pt, ", ") + " }";
    }
    return String(m);
  };
  function V(p, m, D) {
    var $ = (D.quoteStyle || m) === "double" ? '"' : "'";
    return $ + p + $;
  }
  function fe(p) {
    return O.call(String(p), /"/g, "&quot;");
  }
  function H(p) {
    return oe(p) === "[object Array]" && (!T || !(typeof p == "object" && T in p));
  }
  function re(p) {
    return oe(p) === "[object Date]" && (!T || !(typeof p == "object" && T in p));
  }
  function de(p) {
    return oe(p) === "[object RegExp]" && (!T || !(typeof p == "object" && T in p));
  }
  function he(p) {
    return oe(p) === "[object Error]" && (!T || !(typeof p == "object" && T in p));
  }
  function ne(p) {
    return oe(p) === "[object String]" && (!T || !(typeof p == "object" && T in p));
  }
  function J(p) {
    return oe(p) === "[object Number]" && (!T || !(typeof p == "object" && T in p));
  }
  function Z(p) {
    return oe(p) === "[object Boolean]" && (!T || !(typeof p == "object" && T in p));
  }
  function pe(p) {
    if (R)
      return p && typeof p == "object" && p instanceof Symbol;
    if (typeof p == "symbol")
      return !0;
    if (!p || typeof p != "object" || !Q)
      return !1;
    try {
      return Q.call(p), !0;
    } catch {
    }
    return !1;
  }
  function ye(p) {
    if (!p || typeof p != "object" || !U)
      return !1;
    try {
      return U.call(p), !0;
    } catch {
    }
    return !1;
  }
  var it = Object.prototype.hasOwnProperty || function(p) {
    return p in this;
  };
  function ae(p, m) {
    return it.call(p, m);
  }
  function oe(p) {
    return w.call(p);
  }
  function bo(p) {
    if (p.name)
      return p.name;
    var m = y.call(f.call(p), /^function\s*([\w$]+)/);
    return m ? m[1] : null;
  }
  function vr(p, m) {
    if (p.indexOf)
      return p.indexOf(m);
    for (var D = 0, $ = p.length; D < $; D++)
      if (p[D] === m)
        return D;
    return -1;
  }
  function wo(p) {
    if (!r || !p || typeof p != "object")
      return !1;
    try {
      r.call(p);
      try {
        i.call(p);
      } catch {
        return !0;
      }
      return p instanceof Map;
    } catch {
    }
    return !1;
  }
  function So(p) {
    if (!c || !p || typeof p != "object")
      return !1;
    try {
      c.call(p, c);
      try {
        S.call(p, S);
      } catch {
        return !0;
      }
      return p instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Oo(p) {
    if (!d || !p || typeof p != "object")
      return !1;
    try {
      return d.call(p), !0;
    } catch {
    }
    return !1;
  }
  function Eo(p) {
    if (!i || !p || typeof p != "object")
      return !1;
    try {
      i.call(p);
      try {
        r.call(p);
      } catch {
        return !0;
      }
      return p instanceof Set;
    } catch {
    }
    return !1;
  }
  function Po(p) {
    if (!S || !p || typeof p != "object")
      return !1;
    try {
      S.call(p, S);
      try {
        c.call(p, c);
      } catch {
        return !0;
      }
      return p instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Ao(p) {
    return !p || typeof p != "object" ? !1 : typeof HTMLElement < "u" && p instanceof HTMLElement ? !0 : typeof p.nodeName == "string" && typeof p.getAttribute == "function";
  }
  function br(p, m) {
    if (p.length > m.maxStringLength) {
      var D = p.length - m.maxStringLength, $ = "... " + D + " more character" + (D > 1 ? "s" : "");
      return br(h.call(p, 0, m.maxStringLength), m) + $;
    }
    var z = O.call(O.call(p, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, To);
    return V(z, "single", m);
  }
  function To(p) {
    var m = p.charCodeAt(0), D = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[m];
    return D ? "\\" + D : "\\x" + (m < 16 ? "0" : "") + P.call(m.toString(16));
  }
  function Ie(p) {
    return "Object(" + p + ")";
  }
  function at(p) {
    return p + " { ? }";
  }
  function wr(p, m, D, $) {
    var z = $ ? st(D, $) : L.call(D, ", ");
    return p + " (" + m + ") {" + z + "}";
  }
  function Ro(p) {
    for (var m = 0; m < p.length; m++)
      if (vr(p[m], `
`) >= 0)
        return !1;
    return !0;
  }
  function xo(p, m) {
    var D;
    if (p.indent === "	")
      D = "	";
    else if (typeof p.indent == "number" && p.indent > 0)
      D = L.call(Array(p.indent + 1), " ");
    else
      return null;
    return {
      base: D,
      prev: L.call(Array(m + 1), D)
    };
  }
  function st(p, m) {
    if (p.length === 0)
      return "";
    var D = `
` + m.prev + m.base;
    return D + L.call(p, "," + D) + `
` + m.prev;
  }
  function Me(p, m) {
    var D = H(p), $ = [];
    if (D) {
      $.length = p.length;
      for (var z = 0; z < p.length; z++)
        $[z] = ae(p, z) ? m(p[z], p) : "";
    }
    var N = typeof _ == "function" ? _(p) : [], me;
    if (R) {
      me = {};
      for (var be = 0; be < N.length; be++)
        me["$" + N[be]] = N[be];
    }
    for (var ee in p)
      ae(p, ee) && (D && String(Number(ee)) === ee && ee < p.length || R && me["$" + ee] instanceof Symbol || (A.call(/[^\w$]/, ee) ? $.push(m(ee, p) + ": " + m(p[ee], p)) : $.push(ee + ": " + m(p[ee], p))));
    if (typeof _ == "function")
      for (var ge = 0; ge < N.length; ge++)
        M.call(p, N[ge]) && $.push("[" + m(N[ge]) + "]: " + m(p[N[ge]], p));
    return $;
  }
  return Mt;
}
var qt, yn;
function qa() {
  if (yn) return qt;
  yn = 1;
  var e = /* @__PURE__ */ Ce(), t = Ba(), r = /* @__PURE__ */ Ma(), n = /* @__PURE__ */ $e(), o = e("%WeakMap%", !0), a = e("%Map%", !0), i = t("WeakMap.prototype.get", !0), s = t("WeakMap.prototype.set", !0), l = t("WeakMap.prototype.has", !0), c = t("Map.prototype.get", !0), u = t("Map.prototype.set", !0), S = t("Map.prototype.has", !0), b = function(f, y) {
    for (var h = f, O; (O = h.next) !== null; h = O)
      if (O.key === y)
        return h.next = O.next, O.next = /** @type {NonNullable<typeof list.next>} */
        f.next, f.next = O, O;
  }, d = function(f, y) {
    var h = b(f, y);
    return h && h.value;
  }, v = function(f, y, h) {
    var O = b(f, y);
    O ? O.value = h : f.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: y,
      next: f.next,
      value: h
    };
  }, w = function(f, y) {
    return !!b(f, y);
  };
  return qt = function() {
    var y, h, O, P = {
      assert: function(E) {
        if (!P.has(E))
          throw new n("Side channel does not contain " + r(E));
      },
      get: function(E) {
        if (o && E && (typeof E == "object" || typeof E == "function")) {
          if (y)
            return i(y, E);
        } else if (a) {
          if (h)
            return c(h, E);
        } else if (O)
          return d(O, E);
      },
      has: function(E) {
        if (o && E && (typeof E == "object" || typeof E == "function")) {
          if (y)
            return l(y, E);
        } else if (a) {
          if (h)
            return S(h, E);
        } else if (O)
          return w(O, E);
        return !1;
      },
      set: function(E, A) {
        o && E && (typeof E == "object" || typeof E == "function") ? (y || (y = new o()), s(y, E, A)) : a ? (h || (h = new a()), u(h, E, A)) : (O || (O = { key: {}, next: null }), v(O, E, A));
      }
    };
    return P;
  }, qt;
}
var Ht, dn;
function gr() {
  if (dn) return Ht;
  dn = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Ht = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Ht;
}
var Wt, hn;
function fo() {
  if (hn) return Wt;
  hn = 1;
  var e = /* @__PURE__ */ gr(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var f = [], y = 0; y < 256; ++y)
      f.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return f;
  }(), o = function(y) {
    for (; y.length > 1; ) {
      var h = y.pop(), O = h.obj[h.prop];
      if (r(O)) {
        for (var P = [], E = 0; E < O.length; ++E)
          typeof O[E] < "u" && P.push(O[E]);
        h.obj[h.prop] = P;
      }
    }
  }, a = function(y, h) {
    for (var O = h && h.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, P = 0; P < y.length; ++P)
      typeof y[P] < "u" && (O[P] = y[P]);
    return O;
  }, i = function f(y, h, O) {
    if (!h)
      return y;
    if (typeof h != "object") {
      if (r(y))
        y.push(h);
      else if (y && typeof y == "object")
        (O && (O.plainObjects || O.allowPrototypes) || !t.call(Object.prototype, h)) && (y[h] = !0);
      else
        return [y, h];
      return y;
    }
    if (!y || typeof y != "object")
      return [y].concat(h);
    var P = y;
    return r(y) && !r(h) && (P = a(y, O)), r(y) && r(h) ? (h.forEach(function(E, A) {
      if (t.call(y, A)) {
        var F = y[A];
        F && typeof F == "object" && E && typeof E == "object" ? y[A] = f(F, E, O) : y.push(E);
      } else
        y[A] = E;
    }), y) : Object.keys(h).reduce(function(E, A) {
      var F = h[A];
      return t.call(E, A) ? E[A] = f(E[A], F, O) : E[A] = F, E;
    }, P);
  }, s = function(y, h) {
    return Object.keys(h).reduce(function(O, P) {
      return O[P] = h[P], O;
    }, y);
  }, l = function(f, y, h) {
    var O = f.replace(/\+/g, " ");
    if (h === "iso-8859-1")
      return O.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(O);
    } catch {
      return O;
    }
  }, c = 1024, u = function(y, h, O, P, E) {
    if (y.length === 0)
      return y;
    var A = y;
    if (typeof y == "symbol" ? A = Symbol.prototype.toString.call(y) : typeof y != "string" && (A = String(y)), O === "iso-8859-1")
      return escape(A).replace(/%u[0-9a-f]{4}/gi, function(Q) {
        return "%26%23" + parseInt(Q.slice(2), 16) + "%3B";
      });
    for (var F = "", L = 0; L < A.length; L += c) {
      for (var j = A.length >= c ? A.slice(L, L + c) : A, C = [], U = 0; U < j.length; ++U) {
        var _ = j.charCodeAt(U);
        if (_ === 45 || _ === 46 || _ === 95 || _ === 126 || _ >= 48 && _ <= 57 || _ >= 65 && _ <= 90 || _ >= 97 && _ <= 122 || E === e.RFC1738 && (_ === 40 || _ === 41)) {
          C[C.length] = j.charAt(U);
          continue;
        }
        if (_ < 128) {
          C[C.length] = n[_];
          continue;
        }
        if (_ < 2048) {
          C[C.length] = n[192 | _ >> 6] + n[128 | _ & 63];
          continue;
        }
        if (_ < 55296 || _ >= 57344) {
          C[C.length] = n[224 | _ >> 12] + n[128 | _ >> 6 & 63] + n[128 | _ & 63];
          continue;
        }
        U += 1, _ = 65536 + ((_ & 1023) << 10 | j.charCodeAt(U) & 1023), C[C.length] = n[240 | _ >> 18] + n[128 | _ >> 12 & 63] + n[128 | _ >> 6 & 63] + n[128 | _ & 63];
      }
      F += C.join("");
    }
    return F;
  }, S = function(y) {
    for (var h = [{ obj: { o: y }, prop: "o" }], O = [], P = 0; P < h.length; ++P)
      for (var E = h[P], A = E.obj[E.prop], F = Object.keys(A), L = 0; L < F.length; ++L) {
        var j = F[L], C = A[j];
        typeof C == "object" && C !== null && O.indexOf(C) === -1 && (h.push({ obj: A, prop: j }), O.push(C));
      }
    return o(h), y;
  }, b = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, d = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, v = function(y, h) {
    return [].concat(y, h);
  }, w = function(y, h) {
    if (r(y)) {
      for (var O = [], P = 0; P < y.length; P += 1)
        O.push(h(y[P]));
      return O;
    }
    return h(y);
  };
  return Wt = {
    arrayToObject: a,
    assign: s,
    combine: v,
    compact: S,
    decode: l,
    encode: u,
    isBuffer: d,
    isRegExp: b,
    maybeMap: w,
    merge: i
  }, Wt;
}
var zt, mn;
function Ha() {
  if (mn) return zt;
  mn = 1;
  var e = qa(), t = /* @__PURE__ */ fo(), r = /* @__PURE__ */ gr(), n = Object.prototype.hasOwnProperty, o = {
    brackets: function(f) {
      return f + "[]";
    },
    comma: "comma",
    indices: function(f, y) {
      return f + "[" + y + "]";
    },
    repeat: function(f) {
      return f;
    }
  }, a = Array.isArray, i = Array.prototype.push, s = function(w, f) {
    i.apply(w, a(f) ? f : [f]);
  }, l = Date.prototype.toISOString, c = r.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    format: c,
    formatter: r.formatters[c],
    // deprecated
    indices: !1,
    serializeDate: function(f) {
      return l.call(f);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, S = function(f) {
    return typeof f == "string" || typeof f == "number" || typeof f == "boolean" || typeof f == "symbol" || typeof f == "bigint";
  }, b = {}, d = function w(f, y, h, O, P, E, A, F, L, j, C, U, _, Q, R, T, M, B) {
    for (var x = f, q = B, k = 0, W = !1; (q = q.get(b)) !== void 0 && !W; ) {
      var V = q.get(f);
      if (k += 1, typeof V < "u") {
        if (V === k)
          throw new RangeError("Cyclic object value");
        W = !0;
      }
      typeof q.get(b) > "u" && (k = 0);
    }
    if (typeof j == "function" ? x = j(y, x) : x instanceof Date ? x = _(x) : h === "comma" && a(x) && (x = t.maybeMap(x, function(oe) {
      return oe instanceof Date ? _(oe) : oe;
    })), x === null) {
      if (E)
        return L && !T ? L(y, u.encoder, M, "key", Q) : y;
      x = "";
    }
    if (S(x) || t.isBuffer(x)) {
      if (L) {
        var fe = T ? y : L(y, u.encoder, M, "key", Q);
        return [R(fe) + "=" + R(L(x, u.encoder, M, "value", Q))];
      }
      return [R(y) + "=" + R(String(x))];
    }
    var H = [];
    if (typeof x > "u")
      return H;
    var re;
    if (h === "comma" && a(x))
      T && L && (x = t.maybeMap(x, L)), re = [{ value: x.length > 0 ? x.join(",") || null : void 0 }];
    else if (a(j))
      re = j;
    else {
      var de = Object.keys(x);
      re = C ? de.sort(C) : de;
    }
    var he = F ? y.replace(/\./g, "%2E") : y, ne = O && a(x) && x.length === 1 ? he + "[]" : he;
    if (P && a(x) && x.length === 0)
      return ne + "[]";
    for (var J = 0; J < re.length; ++J) {
      var Z = re[J], pe = typeof Z == "object" && typeof Z.value < "u" ? Z.value : x[Z];
      if (!(A && pe === null)) {
        var ye = U && F ? Z.replace(/\./g, "%2E") : Z, it = a(x) ? typeof h == "function" ? h(ne, ye) : ne : ne + (U ? "." + ye : "[" + ye + "]");
        B.set(f, k);
        var ae = e();
        ae.set(b, B), s(H, w(
          pe,
          it,
          h,
          O,
          P,
          E,
          A,
          F,
          h === "comma" && T && a(x) ? null : L,
          j,
          C,
          U,
          _,
          Q,
          R,
          T,
          M,
          ae
        ));
      }
    }
    return H;
  }, v = function(f) {
    if (!f)
      return u;
    if (typeof f.allowEmptyArrays < "u" && typeof f.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof f.encodeDotInKeys < "u" && typeof f.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (f.encoder !== null && typeof f.encoder < "u" && typeof f.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var y = f.charset || u.charset;
    if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var h = r.default;
    if (typeof f.format < "u") {
      if (!n.call(r.formatters, f.format))
        throw new TypeError("Unknown format option provided.");
      h = f.format;
    }
    var O = r.formatters[h], P = u.filter;
    (typeof f.filter == "function" || a(f.filter)) && (P = f.filter);
    var E;
    if (f.arrayFormat in o ? E = f.arrayFormat : "indices" in f ? E = f.indices ? "indices" : "repeat" : E = u.arrayFormat, "commaRoundTrip" in f && typeof f.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var A = typeof f.allowDots > "u" ? f.encodeDotInKeys === !0 ? !0 : u.allowDots : !!f.allowDots;
    return {
      addQueryPrefix: typeof f.addQueryPrefix == "boolean" ? f.addQueryPrefix : u.addQueryPrefix,
      allowDots: A,
      allowEmptyArrays: typeof f.allowEmptyArrays == "boolean" ? !!f.allowEmptyArrays : u.allowEmptyArrays,
      arrayFormat: E,
      charset: y,
      charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : u.charsetSentinel,
      commaRoundTrip: f.commaRoundTrip,
      delimiter: typeof f.delimiter > "u" ? u.delimiter : f.delimiter,
      encode: typeof f.encode == "boolean" ? f.encode : u.encode,
      encodeDotInKeys: typeof f.encodeDotInKeys == "boolean" ? f.encodeDotInKeys : u.encodeDotInKeys,
      encoder: typeof f.encoder == "function" ? f.encoder : u.encoder,
      encodeValuesOnly: typeof f.encodeValuesOnly == "boolean" ? f.encodeValuesOnly : u.encodeValuesOnly,
      filter: P,
      format: h,
      formatter: O,
      serializeDate: typeof f.serializeDate == "function" ? f.serializeDate : u.serializeDate,
      skipNulls: typeof f.skipNulls == "boolean" ? f.skipNulls : u.skipNulls,
      sort: typeof f.sort == "function" ? f.sort : null,
      strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : u.strictNullHandling
    };
  };
  return zt = function(w, f) {
    var y = w, h = v(f), O, P;
    typeof h.filter == "function" ? (P = h.filter, y = P("", y)) : a(h.filter) && (P = h.filter, O = P);
    var E = [];
    if (typeof y != "object" || y === null)
      return "";
    var A = o[h.arrayFormat], F = A === "comma" && h.commaRoundTrip;
    O || (O = Object.keys(y)), h.sort && O.sort(h.sort);
    for (var L = e(), j = 0; j < O.length; ++j) {
      var C = O[j];
      h.skipNulls && y[C] === null || s(E, d(
        y[C],
        C,
        A,
        F,
        h.allowEmptyArrays,
        h.strictNullHandling,
        h.skipNulls,
        h.encodeDotInKeys,
        h.encode ? h.encoder : null,
        h.filter,
        h.sort,
        h.allowDots,
        h.serializeDate,
        h.format,
        h.formatter,
        h.encodeValuesOnly,
        h.charset,
        L
      ));
    }
    var U = E.join(h.delimiter), _ = h.addQueryPrefix === !0 ? "?" : "";
    return h.charsetSentinel && (h.charset === "iso-8859-1" ? _ += "utf8=%26%2310003%3B&" : _ += "utf8=%E2%9C%93&"), U.length > 0 ? _ + U : "";
  }, zt;
}
var Kt, gn;
function Wa() {
  if (gn) return Kt;
  gn = 1;
  var e = /* @__PURE__ */ fo(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, o = function(b) {
    return b.replace(/&#(\d+);/g, function(d, v) {
      return String.fromCharCode(parseInt(v, 10));
    });
  }, a = function(b, d) {
    return b && typeof b == "string" && d.comma && b.indexOf(",") > -1 ? b.split(",") : b;
  }, i = "utf8=%26%2310003%3B", s = "utf8=%E2%9C%93", l = function(d, v) {
    var w = { __proto__: null }, f = v.ignoreQueryPrefix ? d.replace(/^\?/, "") : d, y = v.parameterLimit === 1 / 0 ? void 0 : v.parameterLimit, h = f.split(v.delimiter, y), O = -1, P, E = v.charset;
    if (v.charsetSentinel)
      for (P = 0; P < h.length; ++P)
        h[P].indexOf("utf8=") === 0 && (h[P] === s ? E = "utf-8" : h[P] === i && (E = "iso-8859-1"), O = P, P = h.length);
    for (P = 0; P < h.length; ++P)
      if (P !== O) {
        var A = h[P], F = A.indexOf("]="), L = F === -1 ? A.indexOf("=") : F + 1, j, C;
        L === -1 ? (j = v.decoder(A, n.decoder, E, "key"), C = v.strictNullHandling ? null : "") : (j = v.decoder(A.slice(0, L), n.decoder, E, "key"), C = e.maybeMap(
          a(A.slice(L + 1), v),
          function(_) {
            return v.decoder(_, n.decoder, E, "value");
          }
        )), C && v.interpretNumericEntities && E === "iso-8859-1" && (C = o(C)), A.indexOf("[]=") > -1 && (C = r(C) ? [C] : C);
        var U = t.call(w, j);
        U && v.duplicates === "combine" ? w[j] = e.combine(w[j], C) : (!U || v.duplicates === "last") && (w[j] = C);
      }
    return w;
  }, c = function(b, d, v, w) {
    for (var f = w ? d : a(d, v), y = b.length - 1; y >= 0; --y) {
      var h, O = b[y];
      if (O === "[]" && v.parseArrays)
        h = v.allowEmptyArrays && f === "" ? [] : [].concat(f);
      else {
        h = v.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var P = O.charAt(0) === "[" && O.charAt(O.length - 1) === "]" ? O.slice(1, -1) : O, E = v.decodeDotInKeys ? P.replace(/%2E/g, ".") : P, A = parseInt(E, 10);
        !v.parseArrays && E === "" ? h = { 0: f } : !isNaN(A) && O !== E && String(A) === E && A >= 0 && v.parseArrays && A <= v.arrayLimit ? (h = [], h[A] = f) : E !== "__proto__" && (h[E] = f);
      }
      f = h;
    }
    return f;
  }, u = function(d, v, w, f) {
    if (d) {
      var y = w.allowDots ? d.replace(/\.([^.[]+)/g, "[$1]") : d, h = /(\[[^[\]]*])/, O = /(\[[^[\]]*])/g, P = w.depth > 0 && h.exec(y), E = P ? y.slice(0, P.index) : y, A = [];
      if (E) {
        if (!w.plainObjects && t.call(Object.prototype, E) && !w.allowPrototypes)
          return;
        A.push(E);
      }
      for (var F = 0; w.depth > 0 && (P = O.exec(y)) !== null && F < w.depth; ) {
        if (F += 1, !w.plainObjects && t.call(Object.prototype, P[1].slice(1, -1)) && !w.allowPrototypes)
          return;
        A.push(P[1]);
      }
      return P && A.push("[" + y.slice(P.index) + "]"), c(A, v, w, f);
    }
  }, S = function(d) {
    if (!d)
      return n;
    if (typeof d.allowEmptyArrays < "u" && typeof d.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof d.decodeDotInKeys < "u" && typeof d.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (d.decoder !== null && typeof d.decoder < "u" && typeof d.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof d.charset < "u" && d.charset !== "utf-8" && d.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var v = typeof d.charset > "u" ? n.charset : d.charset, w = typeof d.duplicates > "u" ? n.duplicates : d.duplicates;
    if (w !== "combine" && w !== "first" && w !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var f = typeof d.allowDots > "u" ? d.decodeDotInKeys === !0 ? !0 : n.allowDots : !!d.allowDots;
    return {
      allowDots: f,
      allowEmptyArrays: typeof d.allowEmptyArrays == "boolean" ? !!d.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof d.allowPrototypes == "boolean" ? d.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof d.allowSparse == "boolean" ? d.allowSparse : n.allowSparse,
      arrayLimit: typeof d.arrayLimit == "number" ? d.arrayLimit : n.arrayLimit,
      charset: v,
      charsetSentinel: typeof d.charsetSentinel == "boolean" ? d.charsetSentinel : n.charsetSentinel,
      comma: typeof d.comma == "boolean" ? d.comma : n.comma,
      decodeDotInKeys: typeof d.decodeDotInKeys == "boolean" ? d.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof d.decoder == "function" ? d.decoder : n.decoder,
      delimiter: typeof d.delimiter == "string" || e.isRegExp(d.delimiter) ? d.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof d.depth == "number" || d.depth === !1 ? +d.depth : n.depth,
      duplicates: w,
      ignoreQueryPrefix: d.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof d.interpretNumericEntities == "boolean" ? d.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof d.parameterLimit == "number" ? d.parameterLimit : n.parameterLimit,
      parseArrays: d.parseArrays !== !1,
      plainObjects: typeof d.plainObjects == "boolean" ? d.plainObjects : n.plainObjects,
      strictNullHandling: typeof d.strictNullHandling == "boolean" ? d.strictNullHandling : n.strictNullHandling
    };
  };
  return Kt = function(b, d) {
    var v = S(d);
    if (b === "" || b === null || typeof b > "u")
      return v.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var w = typeof b == "string" ? l(b, v) : b, f = v.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, y = Object.keys(w), h = 0; h < y.length; ++h) {
      var O = y[h], P = u(O, w[O], v, typeof b == "string");
      f = e.merge(f, P, v);
    }
    return v.allowSparse === !0 ? f : e.compact(f);
  }, Kt;
}
var Gt, vn;
function za() {
  if (vn) return Gt;
  vn = 1;
  var e = /* @__PURE__ */ Ha(), t = /* @__PURE__ */ Wa(), r = /* @__PURE__ */ gr();
  return Gt = {
    formats: r,
    parse: t,
    stringify: e
  }, Gt;
}
var Ka = /* @__PURE__ */ za();
const Ga = /* @__PURE__ */ Ue(Ka);
var Vt, bn;
function Va() {
  if (bn) return Vt;
  bn = 1;
  var e = "[object String]", t = Object.prototype, r = t.toString, n = Array.isArray;
  function o(i) {
    return !!i && typeof i == "object";
  }
  function a(i) {
    return typeof i == "string" || !n(i) && o(i) && r.call(i) == e;
  }
  return Vt = a, Vt;
}
var Ja = Va();
const wn = /* @__PURE__ */ Ue(Ja);
var We = { exports: {} }, Sn;
function Qa() {
  if (Sn) return We.exports;
  Sn = 1;
  class e extends Error {
    constructor() {
      super("Throttled function aborted"), this.name = "AbortError";
    }
  }
  const t = ({ limit: r, interval: n, strict: o }) => {
    if (!Number.isFinite(r))
      throw new TypeError("Expected `limit` to be a finite number");
    if (!Number.isFinite(n))
      throw new TypeError("Expected `interval` to be a finite number");
    const a = /* @__PURE__ */ new Map();
    let i = 0, s = 0;
    function l() {
      const b = Date.now();
      return b - i > n ? (s = 1, i = b, 0) : (s < r ? s++ : (i += n, s = 1), i - b);
    }
    const c = [];
    function u() {
      const b = Date.now();
      if (c.length < r)
        return c.push(b), 0;
      const d = c.shift() + n;
      return b >= d ? (c.push(b), 0) : (c.push(d), d - b);
    }
    const S = o ? u : l;
    return (b) => {
      const d = function(...v) {
        if (!d.isEnabled)
          return (async () => b.apply(this, v))();
        let w;
        return new Promise((f, y) => {
          w = setTimeout(() => {
            f(b.apply(this, v)), a.delete(w);
          }, S()), a.set(w, y);
        });
      };
      return d.abort = () => {
        for (const v of a.keys())
          clearTimeout(v), a.get(v)(new e());
        a.clear(), c.splice(0, c.length);
      }, d.isEnabled = !0, d;
    };
  };
  return We.exports = t, We.exports.AbortError = e, We.exports;
}
var Xa = Qa();
const Ya = /* @__PURE__ */ Ue(Xa);
var Jt, On;
function Za() {
  if (On) return Jt;
  On = 1;
  var e = "[object Object]";
  function t(b) {
    var d = !1;
    if (b != null && typeof b.toString != "function")
      try {
        d = !!(b + "");
      } catch {
      }
    return d;
  }
  function r(b, d) {
    return function(v) {
      return b(d(v));
    };
  }
  var n = Function.prototype, o = Object.prototype, a = n.toString, i = o.hasOwnProperty, s = a.call(Object), l = o.toString, c = r(Object.getPrototypeOf, Object);
  function u(b) {
    return !!b && typeof b == "object";
  }
  function S(b) {
    if (!u(b) || l.call(b) != e || t(b))
      return !1;
    var d = c(b);
    if (d === null)
      return !0;
    var v = i.call(d, "constructor") && d.constructor;
    return typeof v == "function" && v instanceof v && a.call(v) == s;
  }
  return Jt = S, Jt;
}
var es = Za();
const ze = /* @__PURE__ */ Ue(es);
function ts(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function En(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? En(Object(r), !0).forEach(function(n) {
      rs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : En(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ar(e) {
  "@babel/helpers - typeof";
  return ar = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ar(e);
}
function sr() {
  sr = function(o, a) {
    return new r(o, void 0, a);
  };
  var e = RegExp.prototype, t = /* @__PURE__ */ new WeakMap();
  function r(o, a, i) {
    var s = new RegExp(o, a);
    return t.set(s, i || t.get(o)), Ze(s, r.prototype);
  }
  function n(o, a) {
    var i = t.get(a);
    return Object.keys(i).reduce(function(s, l) {
      var c = i[l];
      if (typeof c == "number") s[l] = o[c];
      else {
        for (var u = 0; o[c[u]] === void 0 && u + 1 < c.length; ) u++;
        s[l] = o[c[u]];
      }
      return s;
    }, /* @__PURE__ */ Object.create(null));
  }
  return ns(r, RegExp), r.prototype.exec = function(o) {
    var a = e.exec.call(this, o);
    if (a) {
      a.groups = n(a, this);
      var i = a.indices;
      i && (i.groups = n(i, this));
    }
    return a;
  }, r.prototype[Symbol.replace] = function(o, a) {
    if (typeof a == "string") {
      var i = t.get(this);
      return e[Symbol.replace].call(this, o, a.replace(/\$<([^>]+)>/g, function(l, c) {
        var u = i[c];
        return "$" + (Array.isArray(u) ? u.join("$") : u);
      }));
    }
    if (typeof a == "function") {
      var s = this;
      return e[Symbol.replace].call(this, o, function() {
        var l = arguments;
        return typeof l[l.length - 1] != "object" && (l = [].slice.call(l)).push(n(l, s)), a.apply(this, l);
      });
    }
    return e[Symbol.replace].call(this, o, a);
  }, sr.apply(this, arguments);
}
function rs(e, t, r) {
  return t = cs(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ns(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ze(e, t);
}
function Ze(e, t) {
  return Ze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Ze(e, t);
}
function os(e, t) {
  return is(e) || ts(e, t) || po(e, t) || as();
}
function is(e) {
  if (Array.isArray(e)) return e;
}
function po(e, t) {
  if (e) {
    if (typeof e == "string") return Pn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Pn(e, t);
  }
}
function Pn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function as() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ss(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = po(e)) || t) {
      r && (e = r);
      var n = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, i = !1, s;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var l = r.next();
      return a = l.done, l;
    },
    e: function(l) {
      i = !0, s = l;
    },
    f: function() {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw s;
      }
    }
  };
}
function us(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cs(e) {
  var t = us(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function ls() {
  return typeof process < "u" && !process.browser;
}
function fs() {
  return typeof window < "u" && "navigator" in window && "product" in window.navigator && window.navigator.product === "ReactNative";
}
function ps() {
  return process.versions && process.versions.node ? "v".concat(process.versions.node) : process.version;
}
function ys() {
  return window;
}
function ur() {
}
var cr = /* @__PURE__ */ sr(/(\d+)(%)/, {
  value: 1
});
function Qt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7, r = t;
  if (cr.test(e)) {
    var n, o = (n = e.match(cr)) === null || n === void 0 ? void 0 : n.groups;
    if (o && o.value) {
      var a = parseInt(o.value) / 100;
      r = Math.round(t * a);
    }
  }
  return Math.min(30, Math.max(1, r));
}
function An(e, t) {
  return t("info", "Throttle request to ".concat(e, "/s")), Ya({
    limit: e,
    interval: 1e3,
    strict: !1
  });
}
var ds = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", r = e.defaults.logHandler, n = r === void 0 ? ur : r, o = wn(t) ? Qt(t) : Qt("auto", t), a = An(o, n), i = !1, s = e.interceptors.request.use(function(c) {
    return a(function() {
      return c;
    })();
  }, function(c) {
    return Promise.reject(c);
  }), l = e.interceptors.response.use(function(c) {
    if (!i && wn(t) && (t === "auto" || cr.test(t)) && c.headers && c.headers["x-contentful-ratelimit-second-limit"]) {
      var u = parseInt(c.headers["x-contentful-ratelimit-second-limit"]), S = Qt(t, u);
      S !== o && (s && e.interceptors.request.eject(s), o = S, a = An(S, n), s = e.interceptors.request.use(function(b) {
        return a(function() {
          return b;
        })();
      }, function(b) {
        return Promise.reject(b);
      })), i = !0;
    }
    return c;
  }, function(c) {
    return Promise.reject(c);
  });
  return function() {
    e.interceptors.request.eject(s), e.interceptors.response.eject(l);
  };
}, hs = function(t) {
  return new Promise(function(r) {
    setTimeout(r, t);
  });
}, ms = function(t) {
  return Math.pow(Math.SQRT2, t);
};
function gs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, r = e.defaults, n = r.responseLogger, o = n === void 0 ? ur : n, a = r.requestLogger, i = a === void 0 ? ur : a;
  e.interceptors.request.use(function(s) {
    return i(s), s;
  }, function(s) {
    return i(s), Promise.reject(s);
  }), e.interceptors.response.use(function(s) {
    return o(s), s;
  }, function(s) {
    var l = s.response, c = s.config;
    if (o(s), !c || !e.defaults.retryOnError)
      return Promise.reject(s);
    var u = c.attempts || 1;
    if (u > t)
      return s.attempts = c.attempts, Promise.reject(s);
    var S = null, b = ms(u);
    return l ? l.status >= 500 && l.status < 600 ? S = "Server ".concat(l.status) : l.status === 429 && (S = "Rate limit", l.headers && s.response.headers["x-contentful-ratelimit-reset"] && (b = l.headers["x-contentful-ratelimit-reset"])) : S = "Connection", S ? (b = Math.floor(b * 1e3 + Math.random() * 200 + 500), e.defaults.logHandler("warning", "".concat(S, " error occurred. Waiting for ").concat(b, " ms before retrying...")), c.attempts = u + 1, delete c.httpAgent, delete c.httpsAgent, hs(b).then(function() {
      return e(c);
    })) : Promise.reject(s);
  });
}
function vs(e, t) {
  e.interceptors.request.use(function(r) {
    return t().then(function(n) {
      return r.headers = Re(Re({}, r.headers), {}, {
        Authorization: "Bearer ".concat(n)
      }), r;
    });
  });
}
var bs = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
function yo(e, t) {
  var r = {
    insecure: !1,
    retryOnError: !0,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logHandler: function(w, f) {
      if (w === "error" && f) {
        var y = [f.name, f.message].filter(function(h) {
          return h;
        }).join(" - ");
        console.error("[error] ".concat(y)), console.error(f);
        return;
      }
      console.log("[".concat(w, "] ").concat(f));
    },
    // Passed to axios
    headers: {},
    httpAgent: !1,
    httpsAgent: !1,
    timeout: 3e4,
    throttle: 0,
    proxy: !1,
    basePath: "",
    adapter: void 0,
    maxContentLength: 1073741824,
    // 1GB
    maxBodyLength: 1073741824
    // 1GB
  }, n = Re(Re({}, r), t);
  if (!n.accessToken) {
    var o = new TypeError("Expected parameter accessToken");
    throw n.logHandler("error", o), o;
  }
  var a = n.insecure ? "http" : "https", i = n.space ? "".concat(n.space, "/") : "", s = n.defaultHostname, l = n.insecure ? 80 : 443;
  if (n.host && bs.test(n.host)) {
    var c = n.host.split(":");
    if (c.length === 2) {
      var u = os(c, 2);
      s = u[0], l = u[1];
    } else
      s = c[0];
  }
  n.basePath && (n.basePath = "/".concat(n.basePath.split("/").filter(Boolean).join("/")));
  var S = t.baseURL || "".concat(a, "://").concat(s, ":").concat(l).concat(n.basePath, "/spaces/").concat(i);
  !n.headers.Authorization && typeof n.accessToken != "function" && (n.headers.Authorization = "Bearer " + n.accessToken);
  var b = {
    // Axios
    baseURL: S,
    headers: n.headers,
    httpAgent: n.httpAgent,
    httpsAgent: n.httpsAgent,
    paramsSerializer: Ga.stringify,
    proxy: n.proxy,
    timeout: n.timeout,
    adapter: n.adapter,
    maxContentLength: n.maxContentLength,
    maxBodyLength: n.maxBodyLength,
    // Contentful
    logHandler: n.logHandler,
    responseLogger: n.responseLogger,
    requestLogger: n.requestLogger,
    retryOnError: n.retryOnError
  }, d = e.create(b);
  return d.httpClientParams = t, d.cloneWithNewParams = function(v) {
    return yo(e, Re(Re({}, G(t)), v));
  }, n.onBeforeRequest && d.interceptors.request.use(n.onBeforeRequest), typeof n.accessToken == "function" && vs(d, n.accessToken), n.throttle && ds(d, n.throttle), gs(d, n.retryLimit), n.onError && d.interceptors.response.use(function(v) {
    return v;
  }, n.onError), d;
}
function Oe(e) {
  var t = e.query, r = {};
  return delete t.resolveLinks, r.params = G(t), r;
}
function ho(e) {
  var t = Object.getOwnPropertyNames(e), r = ss(t), n;
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var o = n.value, a = e[o];
      a && ar(a) === "object" && ho(a);
    }
  } catch (i) {
    r.e(i);
  } finally {
    r.f();
  }
  return Object.freeze(e);
}
function te(e) {
  return ho(e.sys || {}), e;
}
function Tn() {
  var e = ys();
  if (!e)
    return null;
  var t = e.navigator.userAgent, r = e.navigator.platform, n = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"], o = ["Win32", "Win64", "Windows", "WinCE"], a = ["iPhone", "iPad", "iPod"];
  return n.indexOf(r) !== -1 ? "macOS" : a.indexOf(r) !== -1 ? "iOS" : o.indexOf(r) !== -1 ? "Windows" : /Android/.test(t) ? "Android" : /Linux/.test(r) ? "Linux" : null;
}
function ws() {
  var e = process.platform || "linux", t = process.version || "0.0.0", r = {
    android: "Android",
    aix: "Linux",
    darwin: "macOS",
    freebsd: "Linux",
    linux: "Linux",
    openbsd: "Linux",
    sunos: "Linux",
    win32: "Windows"
  };
  return e in r ? "".concat(r[e] || "Linux", "/").concat(t) : null;
}
function Ss(e, t, r, n) {
  var o = [];
  t && o.push("app ".concat(t)), r && o.push("integration ".concat(r)), o.push("sdk ".concat(e));
  var a = null;
  try {
    fs() ? (a = Tn(), o.push("platform ReactNative")) : ls() ? (a = ws(), o.push("platform node.js/".concat(ps()))) : (a = Tn(), o.push("platform browser"));
  } catch {
    a = null;
  }
  return a && o.push("os ".concat(a)), "".concat(o.filter(function(i) {
    return i !== "";
  }).join("; "), ";");
}
function Y(e) {
  return Object.defineProperty(e, "toPlainObject", {
    enumerable: !1,
    configurable: !1,
    writable: !1,
    value: function() {
      return G(this);
    }
  });
}
function ue(e) {
  var t = e.config, r = e.response, n;
  if (t && t.headers && t.headers.Authorization) {
    var o = "...".concat(t.headers.Authorization.toString().substr(-5));
    t.headers.Authorization = "Bearer ".concat(o);
  }
  if (!ze(r) || !ze(t))
    throw e;
  var a = r == null ? void 0 : r.data, i = {
    status: r == null ? void 0 : r.status,
    statusText: r == null ? void 0 : r.statusText,
    message: "",
    details: {}
  };
  ze(t) && (i.request = {
    url: t.url,
    headers: t.headers,
    method: t.method,
    payloadData: t.data
  }), a && ze(a) && ("requestId" in a && (i.requestId = a.requestId || "UNKNOWN"), "message" in a && (i.message = a.message || ""), "details" in a && (i.details = a.details || {}), "sys" in a && "id" in a.sys && (n = a.sys.id));
  var s = new Error();
  s.name = n && n !== "Unknown" ? n : "".concat(r == null ? void 0 : r.status, " ").concat(r == null ? void 0 : r.statusText);
  try {
    s.message = JSON.stringify(i, null, "  ");
  } catch {
    var l;
    s.message = (l = i == null ? void 0 : i.message) !== null && l !== void 0 ? l : "";
  }
  throw s;
}
function Os(e) {
  return te(Y(e));
}
const Es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapSpace: Os
}, Symbol.toStringTag, { value: "Module" }));
var Ke = { exports: {} }, Rn;
function Ps() {
  return Rn || (Rn = 1, function(e, t) {
    t = e.exports = r, t.getSerialize = n;
    function r(o, a, i, s) {
      return JSON.stringify(o, n(a, s), i);
    }
    function n(o, a) {
      var i = [], s = [];
      return a == null && (a = function(l, c) {
        return i[0] === c ? "[Circular ~]" : "[Circular ~." + s.slice(0, i.indexOf(c)).join(".") + "]";
      }), function(l, c) {
        if (i.length > 0) {
          var u = i.indexOf(this);
          ~u ? i.splice(u + 1) : i.push(this), ~u ? s.splice(u, 1 / 0, l) : s.push(l), ~i.indexOf(c) && (c = a.call(this, l, c));
        } else i.push(c);
        return o == null ? c : o.call(this, l, c);
      };
    }
  }(Ke, Ke.exports)), Ke.exports;
}
var As = Ps();
const Ts = /* @__PURE__ */ Ue(As);
function mo(e) {
  return Object.defineProperty(e, "stringifySafe", {
    enumerable: !1,
    configurable: !1,
    writable: !1,
    value: function() {
      let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return Ts(this, t, r, (n, o) => ({
        sys: {
          type: "Link",
          linkType: "Entry",
          id: o.sys.id,
          circular: !0
        }
      }));
    }
  });
}
var Rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, xs = /* @__PURE__ */ function() {
  function e(t, r) {
    var n = [], o = !0, a = !1, i = void 0;
    try {
      for (var s = t[Symbol.iterator](), l; !(o = (l = s.next()).done) && (n.push(l.value), !(r && n.length === r)); o = !0)
        ;
    } catch (c) {
      a = !0, i = c;
    } finally {
      try {
        !o && s.return && s.return();
      } finally {
        if (a) throw i;
      }
    }
    return n;
  }
  return function(t, r) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}();
function Ne(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var je = {}, _s = function(t) {
  return t && t.sys && t.sys.type === "Link";
}, Cs = function(t) {
  return t && t.sys && t.sys.type === "ResourceLink";
}, Is = function(t) {
  return t.space && t.environment ? [t.type + "!" + t.id, t.space.sys.id + "!" + t.environment.sys.id + "!" + t.type + "!" + t.id] : [t.type + "!" + t.id];
}, xn = function(t, r) {
  var n = r.entryId, o = r.linkType, a = r.spaceId, i = r.environmentId;
  return a && i ? t.get(a + "!" + i + "!" + o + "!" + n) : t.get(o + "!" + n);
}, Fs = function(t) {
  var r = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
  if (r.test(t)) {
    var n = t.match(r), o = xs(n, 4);
    o[0];
    var a = o[1], i = o[2], s = i === void 0 ? "master" : i, l = o[3];
    return { spaceId: a, environmentId: s, entryId: l };
  }
}, Ls = function(t, r) {
  var n = r.sys, o = n.type, a = n.linkType;
  if (o === "ResourceLink") {
    var i = r.sys.urn, s = Fs(i), l = s.spaceId, c = s.environmentId, u = s.entryId, S = a.split(":")[1];
    return xn(t, {
      linkType: S,
      entryId: u,
      spaceId: l,
      environmentId: c
    }) || je;
  }
  var b = r.sys.id;
  return xn(t, { linkType: a, entryId: b }) || je;
}, Ns = function(t) {
  if (Array.isArray(t))
    return t.filter(function(n) {
      return n !== je;
    });
  for (var r in t)
    t[r] === je && delete t[r];
  return t;
}, Ds = function e(t, r, n, o) {
  if (r(t))
    return n(t);
  if (t && (typeof t > "u" ? "undefined" : Rs(t)) === "object") {
    for (var a in t)
      t.hasOwnProperty(a) && (t[a] = e(t[a], r, n, o));
    o && (t = Ns(t));
  }
  return t;
}, js = function(t, r, n) {
  var o = Ls(t, r);
  return o === je ? n ? o : r : o;
}, Bs = function(t, r) {
  if (!Array.isArray(r))
    return t;
  var n = Object.keys(t).filter(function(o) {
    return r.indexOf(o) !== -1;
  });
  return n.reduce(function(o, a) {
    return o[a] = t[a], o;
  }, {});
}, go = function(t, r) {
  if (r = r || {}, !t.items)
    return [];
  var n = G(t), o = Object.keys(n.includes || {}).reduce(function(s, l) {
    return [].concat(Ne(s), Ne(t.includes[l]));
  }, []), a = [].concat(Ne(n.items), Ne(o)).filter(function(s) {
    return !!s.sys;
  }), i = new Map(a.reduce(function(s, l) {
    var c = Is(l.sys).map(function(u) {
      return [u, l];
    });
    return s.push.apply(s, Ne(c)), s;
  }, []));
  return a.forEach(function(s) {
    var l = Bs(s, r.itemEntryPoints);
    Object.assign(s, Ds(l, function(c) {
      return _s(c) || Cs(c);
    }, function(c) {
      return js(i, c, r.removeUnresolved);
    }, r.removeUnresolved));
  }), n.items;
};
function ks(e) {
  return te(Y(G(e)));
}
function Us(e, t) {
  let {
    resolveLinks: r,
    removeUnresolved: n
  } = t;
  const o = mo(Y(G(e)));
  return r && (o.items = go(o, {
    removeUnresolved: n,
    itemEntryPoints: ["fields"]
  })), te(o);
}
const $s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapEntry: ks,
  wrapEntryCollection: Us
}, Symbol.toStringTag, { value: "Module" }));
function Ms(e) {
  return te(Y(G(e)));
}
function qs(e) {
  return te(Y(G(e)));
}
const Hs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapAsset: Ms,
  wrapAssetCollection: qs
}, Symbol.toStringTag, { value: "Module" }));
function Ws(e) {
  return te(Y(G(e)));
}
const zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapAssetKey: Ws
}, Symbol.toStringTag, { value: "Module" }));
function Ks(e) {
  return te(Y(G(e)));
}
function Gs(e) {
  return te(Y(G(e)));
}
const Vs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapContentType: Ks,
  wrapContentTypeCollection: Gs
}, Symbol.toStringTag, { value: "Module" }));
function Js(e) {
  return te(Y(G(e)));
}
function Qs(e) {
  return te(Y(G(e)));
}
const Xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapLocale: Js,
  wrapLocaleCollection: Qs
}, Symbol.toStringTag, { value: "Module" }));
function Ys(e) {
  return te(Y(G(e)));
}
function Zs(e) {
  return te(Y(G(e)));
}
const eu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wrapTag: Ys,
  wrapTagCollection: Zs
}, Symbol.toStringTag, { value: "Module" })), Se = {
  space: Es,
  entry: $s,
  asset: Hs,
  assetKey: zs,
  contentType: Vs,
  locale: Xs,
  tag: eu
};
function _n(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _n(Object(r), !0).forEach(function(n) {
      tu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _n(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tu(e, t, r) {
  return t = ru(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ru(e) {
  var t = nu(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function nu(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
async function ou(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t || !t.initial && !t.nextSyncToken && !t.nextPageToken)
    throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
  if (t && t.content_type && !t.type)
    t.type = "Entry";
  else if (t && t.content_type && t.type && t.type !== "Entry")
    throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
  const n = {
    resolveLinks: !0,
    removeUnresolved: !1,
    paginate: !0
  }, {
    resolveLinks: o,
    removeUnresolved: a,
    paginate: i
  } = Cn(Cn({}, n), r), l = await vo(e, [], t, {
    paginate: i
  });
  o && (l.items = go(l, {
    removeUnresolved: a,
    itemEntryPoints: ["fields"]
  }));
  const c = iu(l.items);
  return l.nextSyncToken && (c.nextSyncToken = l.nextSyncToken), l.nextPageToken && (c.nextPageToken = l.nextPageToken), te(mo(Y(c)));
}
function iu(e) {
  const t = (r) => (n, o) => (o.sys.type === r && n.push(Y(o)), n);
  return {
    entries: e.reduce(t("Entry"), []),
    assets: e.reduce(t("Asset"), []),
    deletedEntries: e.reduce(t("DeletedEntry"), []),
    deletedAssets: e.reduce(t("DeletedAsset"), [])
  };
}
async function vo(e, t, r, n) {
  let {
    paginate: o
  } = n;
  r.nextSyncToken && (r.sync_token = r.nextSyncToken, delete r.nextSyncToken), r.nextPageToken && (r.sync_token = r.nextPageToken, delete r.nextPageToken), r.sync_token && (delete r.initial, delete r.type, delete r.content_type, delete r.limit);
  const i = (await e.get("sync", Oe({
    query: r
  }))).data || {};
  return t = t.concat(i.items || []), i.nextPageUrl ? o ? (delete r.initial, r.sync_token = Xt(i.nextPageUrl), vo(e, t, r, {
    paginate: o
  })) : {
    items: t,
    nextPageToken: Xt(i.nextPageUrl)
  } : i.nextSyncUrl ? {
    items: t,
    nextSyncToken: Xt(i.nextSyncUrl)
  } : {
    items: []
  };
}
function Xt(e) {
  const t = e.split("?");
  return t.length > 0 ? t[1].replace("sync_token=", "") : "";
}
function In(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? In(Object(r), !0).forEach(function(n) {
      au(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : In(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function au(e, t, r) {
  return t = su(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function su(e) {
  var t = uu(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function uu(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ge(e) {
  if (!e.select)
    return e;
  const t = Array.isArray(e.select) ? e.select : e.select.split(",").map((n) => n.trim()), r = new Set(t);
  return r.has("sys") ? e : (r.add("sys.id"), r.add("sys.type"), Fn(Fn({}, e), {}, {
    select: [...r].join(",")
  }));
}
class Yt extends Error {
  constructor(t, r) {
    super(`Invalid "${t}" provided, ` + r), this.name = "ValidationError";
  }
}
function cu(e, t, r) {
  if (r = r || {}, typeof t != "number")
    throw new Yt(e, `only numeric values are allowed for timestamps, provided type was "${typeof t}"`);
  if (r.maximum && t > r.maximum)
    throw new Yt(e, `value (${t}) cannot be further in the future than expected maximum (${r.maximum})`);
  if (r.now && t < r.now)
    throw new Yt(e, `value (${t}) cannot be in the past, current time was ${r.now}`);
}
function Ln(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ln(Object(r), !0).forEach(function(n) {
      lu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ln(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function lu(e, t, r) {
  return t = fu(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function fu(e) {
  var t = pu(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function pu(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const yu = 48 * 60 * 60;
function du(e) {
  let {
    http: t,
    getGlobalOptions: r
  } = e;
  const {
    wrapSpace: n
  } = Se.space, {
    wrapContentType: o,
    wrapContentTypeCollection: a
  } = Se.contentType, {
    wrapEntry: i,
    wrapEntryCollection: s
  } = Se.entry, {
    wrapAsset: l,
    wrapAssetCollection: c
  } = Se.asset, {
    wrapTag: u,
    wrapTagCollection: S
  } = Se.tag, {
    wrapAssetKey: b
  } = Se.assetKey, {
    wrapLocaleCollection: d
  } = Se.locale, v = (R) => {
    const T = new Error("The resource could not be found.");
    return T.sys = {
      type: "Error",
      id: "NotFound"
    }, T.details = {
      type: "Entry",
      id: R,
      environment: r().environment,
      space: r().space
    }, T;
  };
  async function w() {
    Q(t);
    try {
      const R = await t.get("/");
      return n(R.data);
    } catch (R) {
      ue(R);
    }
  }
  async function f(R) {
    _(t);
    try {
      const T = await t.get(`content_types/${R}`);
      return o(T.data);
    } catch (T) {
      ue(T);
    }
  }
  async function y() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(t);
    try {
      const T = await t.get("content_types", Oe({
        query: R
      }));
      return a(T.data);
    } catch (T) {
      ue(T);
    }
  }
  async function h(R) {
    let T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!R)
      throw v(R);
    try {
      const M = await this.getEntries(Nn({
        "sys.id": R
      }, T));
      if (M.items.length > 0)
        return i(M.items[0]);
      throw v(R);
    } catch (M) {
      ue(M);
    }
  }
  async function O() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(t);
    const {
      resolveLinks: T,
      removeUnresolved: M
    } = r(R);
    R = Ge(R);
    try {
      const B = await t.get("entries", Oe({
        query: R
      }));
      return s(B.data, {
        resolveLinks: T,
        removeUnresolved: M
      });
    } catch (B) {
      ue(B);
    }
  }
  async function P(R) {
    let T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _(t), T = Ge(T);
    try {
      const M = await t.get(`assets/${R}`, Oe({
        query: T
      }));
      return l(M.data);
    } catch (M) {
      ue(M);
    }
  }
  async function E() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(t), R = Ge(R);
    try {
      const T = await t.get("assets", Oe({
        query: R
      }));
      return c(T.data);
    } catch (T) {
      ue(T);
    }
  }
  async function A(R) {
    _(t);
    try {
      const T = await t.get(`tags/${R}`);
      return u(T.data);
    } catch (T) {
      ue(T);
    }
  }
  async function F() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(t), R = Ge(R);
    try {
      const T = await t.get("tags", Oe({
        query: R
      }));
      return S(T.data);
    } catch (T) {
      ue(T);
    }
  }
  async function L(R) {
    _(t);
    try {
      const T = Math.floor(Date.now() / 1e3), M = T + yu;
      cu("expiresAt", R, {
        maximum: M,
        now: T
      });
      const B = {
        expiresAt: R
      }, x = await t.post("asset_keys", B);
      return b(x.data);
    } catch (T) {
      ue(T);
    }
  }
  async function j() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(t);
    try {
      const T = await t.get("locales", Oe({
        query: R
      }));
      return d(T.data);
    } catch (T) {
      ue(T);
    }
  }
  async function C() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      paginate: !0
    };
    const {
      resolveLinks: M,
      removeUnresolved: B
    } = r(R);
    return _(t), ou(t, R, Nn({
      resolveLinks: M,
      removeUnresolved: B
    }, T));
  }
  function U(R) {
    const {
      resolveLinks: T,
      removeUnresolved: M
    } = r({});
    return s(R, {
      resolveLinks: T,
      removeUnresolved: M
    });
  }
  function _(R) {
    R.defaults.baseURL = r().environmentBaseUrl;
  }
  function Q(R) {
    R.defaults.baseURL = r().spaceBaseUrl;
  }
  return {
    getSpace: w,
    getContentType: f,
    getContentTypes: y,
    getEntry: h,
    getEntries: O,
    getAsset: P,
    getAssets: E,
    getTag: A,
    getTags: F,
    createAssetKey: L,
    getLocales: j,
    parseEntries: U,
    sync: C
  };
}
function hu(e) {
  return function(r) {
    return Object.assign({}, e, r);
  };
}
function Dn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ve(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dn(Object(r), !0).forEach(function(n) {
      mu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mu(e, t, r) {
  return t = gu(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gu(e) {
  var t = vu(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function vu(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bu(e) {
  if (!e.accessToken)
    throw new TypeError("Expected parameter accessToken");
  if (!e.space)
    throw new TypeError("Expected parameter space");
  const r = Ve(Ve({}, {
    resolveLinks: !0,
    removeUnresolved: !1,
    defaultHostname: "cdn.contentful.com",
    environment: "master"
  }), e), n = Ss("contentful.js/9.3.6", r.application, r.integration);
  r.headers = Ve(Ve({}, r.headers), {}, {
    "Content-Type": "application/vnd.contentful.delivery.v1+json",
    "X-Contentful-User-Agent": n
  });
  const o = yo(K, r), a = hu({
    resolveLinks: r.resolveLinks,
    environment: r.environment,
    removeUnresolved: r.removeUnresolved,
    spaceBaseUrl: o.defaults.baseURL,
    environmentBaseUrl: `${o.defaults.baseURL}environments/${r.environment}`
  });
  return o.defaults.baseURL = a().environmentBaseUrl, du({
    http: o,
    getGlobalOptions: a
  });
}
class wu {
  constructor(t, r) {
    we(this, "accessToken");
    we(this, "spaceId");
    this.accessToken = t, this.spaceId = r;
  }
  createContentfulClient() {
    return bu({
      space: this.spaceId,
      accessToken: this.accessToken
    });
  }
}
class Mu {
  constructor(t, r) {
    we(this, "client");
    we(this, "getSpace", async () => await this.client.getSpace());
    we(this, "getEntries", async ({ locale: t, ...r }) => await this.client.getEntries({
      locale: No(t) ? t : Lo(),
      ...r
    }));
    we(this, "getAsset", async (t) => await this.client.getAsset(t));
    this.client = new wu(t, r).createContentfulClient();
  }
}
export {
  Mu as ContentfulClientConsumer
};
//# sourceMappingURL=content.js.map
